import React, { useState, useEffect, useRef } from "react";
// import { useMemo } from "react";
import isEqual from "lodash/isEqual"; // or implement deep comparison
// import toast from 'react-hot-toast';
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import toast from "react-hot-toast";
import { useNavigate, useLocation } from "react-router-dom";

import Layout from "../../../Layout/Layout";
import Loader from "../../../Components/Loader";

import {
  validateBankAccount,
  validateIBAN,
  validateIFSC,
  validateSWIFT,
} from "../../../common/Validations";

//API
import ItemService from "../../../services/supplier_appCommonService";

//Redux
import { useSelector, useDispatch } from "react-redux"; //useDispatch
import {
  getSupplierCategorySelection,
  getSupplierList,
} from "../../../redux/feature/supplier_app/supplierSlice";

//Components
import { InputField } from "../../../Components/formElements/InputField";
import {
  ComboboxField,
  ComboboxField2,
} from "../../../Components/formElements/ComboboxField";
import { TextAreaField } from "../../../Components/formElements/TextAreaField";
import CategorySelectionModal from "../../../Components/Modal/supplier_app/CategorySelectionModal";
import DataTable from "react-data-table-component";
import Constants from "../../../common/SupplierConstants";
import SuccessRegisterModal from "../../../Components/SuccessRegisterModal";
import FailureModal from "../../../Components/Modal/supplier_app/FailureModal";
import {
  validateContactNumber,
  validateEmail,
  validateName,
  validateTextArea,
  validatePostalCodeForCountry,
} from "../../../common/Validations";
import { ComboboxFieldSubArray } from "../../../Components/formElements/ComboboxFieldSubArray";
import FileUploadComponent from "../../../Components/formElements/FileUploadComponent";
import FileViewerModal from "../../../Components/FileViewer/FileViewerModal";
import CommonFillter from "../../../Components/Filter/Supplier/SupplierCommonFillter";

const message = {
  SPECIAL_CHAR_SUPPLIER_NAME: "Special characters or numbers are not allowed.",
  VALID_MAIL_ID: "Please enter a valid email address.",
  VALID_ALTERNATE_MAIL_ID: "Please enter a valid alternate email address.",
  VALID_CONTACT_NUMBER: "Please enter a valid contact number.",
  VALID_ALTERNATE_CONTACT_NUMBER:
    "Please enter a valid alternate contact number.",
  VALID_PURPOSE_JUSTIFICATION:
    "Please ensure the justification is under 500 characters.",
  VALID_POSTAL_CODE:
    "Please enter a valid postal code / PO Box for the selected country",
  VALID_CONTACT_FIRST_NAME: "Special characters and numbers are not allowed",
  VALID_CONTACT_LAST_NAME: "Special characters and numbers are not allowed",
  EXIStS_SUPPLIER_NAME: "Supplier Name already exists",
  EXIStS_MAIL_ID: "Email already exists",
  EXIStS_CONTACT_NUMBER: "Contact Number already exists",
  EXIStS_ALTERNATE_CONTACT_NUMBER: "Contact Number already exists",
  EXIStS_ALTERNATE_MAIL_ID: "Alternate Contact Number already exists",
  EXIStS_DOCUMENT_NUMBER: "Document Number already exists",
  EXIStS_ADDRESS: "Address already exists",
  FILL_REQUIRED_FIELD: "Please fill the required field",
  ALTERNATE_MAIL_ID: "Email ID Should Not be Same!",
  ALTERNATE_CONTACT_NUMBER: "Contact number Should Not be Same!",
};

// Alphabetical order for master-data dropdowns, by readable name ("India"),
// ignoring case and accents. Returns a new array (never mutates API data).
const labelCollator = new Intl.Collator(undefined, {
  sensitivity: "base",
  numeric: true,
});
const labelOf = (item) => String(item?.description || item?.name || "").trim();
const sortByLabel = (list) =>
  Array.isArray(list)
    ? [...list].sort((a, b) => labelCollator.compare(labelOf(a), labelOf(b)))
    : [];

// Attachments the Financial Info section marks as required (red *). Edit this list to
// change which bank documents are mandatory.
const REQUIRED_BANK_ATTACHMENTS = {
  bankCompanyletterhead: "Company letterhead",
  bankConfirmationLetter: "Confirmation letter",
  chipsCode: "Correspondence Bank Details",
  turnover1Atch: "Year 1 - Turnover document",
  turnover2Atch: "Year 2 - Turnover document",
};

// Returns the list of problems for one bank entry (empty list = valid). Each problem names
// the field to highlight, the text listed in the toast and the text shown under the field.
const getBankProblems = (bank = {}) => {
  const problems = [];
  const missing = (field, text) =>
    problems.push({ field, text, fieldError: message.FILL_REQUIRED_FIELD });
  const invalid = (field, text) =>
    problems.push({ field, text, fieldError: text });
  const listed = bank.bankNotListed;

  if (!listed) {
    missing("bankNotListed", "answer 'Is the Company bank included on list?'");
  } else if (listed === "Yes" && !bank.bankKey) {
    missing("bankKey", "select the BankID");
  } else if (listed === "No") {
    if (!bank.bankName) missing("bankName", "Bank Name is required");
    if (!bank.bankCountry) missing("bankCountry", "Bank Country is required");
  }

  if (!bank.bankAccountNumber) {
    missing("bankAccountNumber", "Bank A/C Number is required");
  } else if (!validateBankAccount(String(bank.bankAccountNumber))) {
    invalid("bankAccountNumber", "Bank A/C Number must be 6-18 digits");
  }

  if (!bank.AccountHolderName?.trim())
    missing("AccountHolderName", "Name of Beneficiary is required");

  if (!bank.swiftIfscCode) {
    missing("swiftIfscCode", "Swift / IFSC Code is required");
  } else if (
    !validateIFSC(bank.swiftIfscCode) &&
    !validateSWIFT(bank.swiftIfscCode)
  ) {
    invalid(
      "swiftIfscCode",
      "Swift / IFSC Code is not valid (e.g. ICIC0001234 or ARABAEAD)",
    );
  }

  // IBAN is optional (not used in India) but must be valid when given
  if (bank.iban && !validateIBAN(String(bank.iban)))
    invalid("iban", "IBAN is not valid (e.g. GB82WEST12345698765432)");

  Object.entries(REQUIRED_BANK_ATTACHMENTS).forEach(([field, label]) => {
    if (!bank[field])
      problems.push({
        field,
        text: `upload ${label}`,
        fieldError: "Please upload this document",
      });
  });

  return problems;
};

// { fieldName: message } for one bank entry, used for the red border + message under each field
const getBankFieldErrors = (bank) =>
  Object.fromEntries(
    getBankProblems(bank).map(({ field, fieldError }) => [field, fieldError]),
  );

const SupplierSelfRegistration = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { draftId: draftIdParam, newDraft: newDraftParam } =
    location.state || {};
  const dispatch = useDispatch();

  useEffect(() => {
    localStorage.setItem("menu", "Vendor");
    localStorage.setItem("submenu", "Vendor List");
  }, []);

  let userInfo = useSelector((state) => state?.user?.data); // User Details from Store
  let selectedCategoryData = useSelector(
    (state) => state?.supplier?.selectedCategory,
  ); // User Details from Store
  let accountGroupName = useSelector((state) => state?.supplier?.accountGroup); // User Details from Store

  // Format the price above to USD using the locale, style, and currency.
  // let USDollar = new Intl.NumberFormat("en-US", {
  //   style: "currency",
  //   currency: "USD",
  // });

  const modalData = {
    title: "Supplier Registration",
    successMsg: "",
  };

  let qmsOptions = [
    {
      id: "1",
      name: "Yes",
    },
    {
      id: "2",
      name: "No",
    },
  ];

  /* pop failure modal */
  const failureModalData = {
    title: "Warning",
    ErrorMsg: "",
  };

  const [getDropdownData, setDropdownData] = useState("");

  // const [data, setData] = useState([]);

  // const [loading, setLoading] = useState(false);
  const [isCardVisible, setCardVisible] = useState(true);
  const [isCardVisible2, setCardVisible2] = useState(true);
  const [isCardVisible3, setCardVisible3] = useState(true);
  const [isCardVisible4, setCardVisible4] = useState(true);
  const [isCardVisible8, setCardVisible8] = useState(true);
  const [modalShow, setModalShow] = useState(false);
  const [getSelectedData, setSelectedData] = useState([]);
  const [getDisabledRemove, setDisabledRemove] = useState(true);
  // eslint-disable-next-line no-unused-vars
  const [getPurchaseOrg, setPurchaseOrg] = useState([]);
  // eslint-disable-next-line no-unused-vars
  const [getCompanyCode, setCompanyCode] = useState([]);

  const [getCountry, setCountry] = useState([]);
  // State/region lists cached per country code, e.g. { IN: [...], AE: [...] }.
  // The company address and every project read the list for their own country,
  // so picking a project country no longer replaces the company address options.
  const [statesByCountry, setStatesByCountry] = useState({});
  const requestedStateCountries = useRef(new Set());

  // Country code for a stored country. Older drafts and the default project
  // ("IN - India") hold only the name, so fall back to the master list / "CODE - Name" format.
  const countryCodeOf = (name, code) => {
    if (code) return code;
    if (!name || typeof name !== "string") return "";
    const match = getCountry.find((c) => c.name === name);
    if (match?.code) return match.code;
    return name.includes(" - ") ? name.split(" - ")[0].trim() : "";
  };

  const [getTitle, setTitle] = useState([]);
  const [getcontactPosition, setcontactPosition] = useState([]);
  const [getShowSuccessModal, setShowSuccessModal] = useState(false);
  const [getSupplierType, setSupplierType] = useState([]);
  const [getModalInfo, setModalInfo] = useState(modalData);
  // eslint-disable-next-line no-unused-vars
  const [getFailureModal, setFailureModal] = useState(failureModalData);
  const [getShowFailureModal, setShowFailureModal] = useState(false);
  // eslint-disable-next-line no-unused-vars
  const [getErrorFields, setErrorFields] = useState([]);
  // DOcument Uploads
  const [getdocumentType, setdocumentType] = useState([]);

  const [getDisabledStatus, setDisabledStatus] = useState(false);
  // const [/*initalData*/, setInitalData] = useState([]);

  const [draftData, setDraftData] = useState(null);

  const previousFormInputsRef = useRef(null);
  const isFirstAutoSave = useRef(true);
  const draftDataRef = useRef(null);
  const [isLoadingDraft, setIsLoadingDraft] = useState(true);

  const createEmptyFormInputs = () => ({
    email: "",
    organisationName: "",
    // firstName: "",
    version: "v0",
    status: "Non Invited",
    contactfirstName: "",
    contactlastName: "",
    contactNumber: "",
    category: "VENDOR",
    vendorCode: "",
    mou: "",
    mouAttachment: "",
    mouDate: "",
    descriptionMou: "",
    mouamendent: "",
    qms: "",
    paymentsTerm: "",
    subCategory: [{ categoryId: "TEMP-VENDOR", active: true }],
    roles: [{ roleId: "TEMP-VENDOR", active: true }],
    accountGroup: accountGroupName,
    companyName: "",
    address: "",
    address2: "",
    city: "",
    state: "",
    country: "",
    contactTitle: "",
    cityPostalCode: "",
    ISOCertification: "",
    ICVCertificate: "",
    CompanyBrochure: "",
    companyBrochure1: "",
    purposeJustification: "",
    natureOfBusiness: "",
    vendorCategory: [],
    purchaseOrg: "",
    companyCode: "",
    contactDetails: [],
    // ✨ New fields
    bankDetails: [],
    documentTypeData: [],
    projectDetails: [],
  });

  // Use this factory for initial state
  const [formInputs, setFormInputs] = useState(createEmptyFormInputs);

  const calculateDraftProgress = (formData) => {
    let score = 0;

    // Primary Data (20%)
    if (formData.organisationName) score += 10;
    if (formData.address) score += 5;
    if (formData.city) score += 5;

    // Country/State/Postal (15%)
    if (formData.country) score += 5;
    if (formData.state) score += 5;
    if (formData.cityPostalCode) score += 5;

    // Contact Person (25%)
    if (formData.contactfirstName) score += 5;
    if (formData.contactlastName) score += 5;
    if (formData.email) score += 5;
    if (formData.contactNumber) score += 5;
    if (formData.contactPosition) score += 5;

    // More Information (15%)
    if (formData.CompanyBrochure) score += 5;
    if (formData.supplierType) score += 5;
    if (formData.purposeJustification) score += 5;

    // Classification (10%) – at least one category selected
    if (formData.vendorCategory?.length > 0) score += 10;

    // Bank Details (15%) – at least one bank entry with account number and bank key
    if (formData.bankDetails?.length > 0) {
      const hasValidBank = formData.bankDetails.some(
        // BankID when the bank is on the list, typed bank name when it is not
        (bank) => bank.bankAccountNumber && (bank.bankKey || bank.bankName),
      );
      if (hasValidBank) score += 15;
    }

    // Optional: Documents / Declaration (5%) – at least one document attached
    // if (formData.documentTypeData?.length > 0) score += 5;

    return Math.min(score, 100);
  };

  const [validation, setValidation] = useState({
    organisationName: "",
    alternateContactNumber: "",
    alternateEmailId: "",
    purposeJustification: "",
    contactNumber: "",
    email: "",
    cityPostalCode: "",
    address: "",
    address2: "",
    city: "",
    country: "",
    state: "",
    contactfirstName: "",
    contactlastName: "",
    contactPosition: "",
    contactTitle: "",
    ISOCertification: "",
    CompanyBrochure: "",
    supplierType: "",
    paymentsTerm: "",
    documentNumber: "",
    // qms: "",
  });
  // ADD new projects
  const newProject = {
    projectCode: 1,
    projectCodeDesc: "PROJECT_1",
    projectName: "",
    projectAddress: "",
    projectAddress2: "",
    projectCity: "",
    projectCountry: "IN - India",
    projectState: "IN - Karnataka",
    projectCityPostalCode: "",
    getProjectContactPerson: [
      {
        id: Date.now(), // Unique ID for the first contact person
        projectContactPosition: "",
        projectContactTitle: "",
        projectContactName: "",
        projectContactNumber: "",
        projectContactEmail: "",
      },
    ],
    getProjectCertifications: [
      {
        id: Date.now(),
        name: "Document 1",
        documentType: "",
        certificateCode: "",
        stageDocument: "",
      },
    ],
    getLocations: [],
  };

  const [nextId, setNextId] = useState(1); // Start IDs from 1
  let productDocumentAttachment = [
    {
      id: "1",
      name: "Stage1",
    },
    {
      id: "2",
      name: "Stage2",
    },
    {
      id: "3",
      name: "Stage3",
    },
    {
      id: "4",
      name: "Stage4",
    },
    {
      id: "5",
      name: "Stage5",
    },

    {
      id: "6",
      name: "Google Pin location",
    },
    {
      id: "7",
      name: "Project Photos",
    },
    {
      id: "8",
      name: "Blueprints or Layout Plans",
    },
    {
      id: "9",
      name: "Project Document",
    },
    {
      id: "10",
      name: "Others",
    },
  ];
  let PaymentTermsOptions = [
    {
      id: "1",
      name: "90 Days",
    },
    {
      id: "2",
      name: "60 Days",
    },
    {
      id: "3",
      name: "45 Days",
    },
  ];
  //show view file
  const [getShowFileViewModal, setShowFileViewModal] = useState(false);
  const [getFileViewData, setFileViewData] = useState(null);

  const [getBankDetailsData, setBankDetailsData] = useState([]);
  // One flag per bank entry: true once Create was clicked with that entry present. Its fields
  // are then highlighted, and re-checked on every change so a fixed field clears straight away.
  const [checkedBanks, setCheckedBanks] = useState([]);
  // Per bank entry, the fields the user has left (blurred), e.g. [{ iban: true }]. A field that
  // was left with a value shows its format error right away, before Create is clicked.
  const [blurredBankFields, setBlurredBankFields] = useState([]);

  const handleViewFile = (fileAttachmentId) => {
    setFileViewData(fileAttachmentId);
    setShowFileViewModal(true);
  };
  const handleViewFileHide = () => {
    setShowFileViewModal(false);
  };

  /* Show Success Modal */
  const onSuccessfullyRegistered = () => {
    setShowSuccessModal(true);
  };

  const hideSuccessModal = () => {
    setShowSuccessModal(false);
  };

  const toggleCardVisibility = () => {
    setCardVisible(!isCardVisible);
  };
  const toggleCardVisibility2 = () => {
    setCardVisible2(!isCardVisible2);
  };
  const toggleCardVisibility3 = () => {
    setCardVisible3(!isCardVisible3);
  };
  const toggleCardVisibility4 = () => {
    setCardVisible4(!isCardVisible4);
  };
  const toggleCardVisibility8 = () => {
    setCardVisible8(!isCardVisible8);
  };

  /* Modal Function */
  const categorySelection = () => {
    setModalShow(true);
  };
  const hideModal = () => {
    setModalShow(false);
  };

  // get SelectedCatData
  // const getSelectedCatData = (data) => {
  //   // console.log(">> getSelectedCatData ", data);
  //   setData(data);
  //   // formInputs.vendorCategory = data;
  //   setFormInputs(prev => ({ ...prev, vendorCategory: data }));
  // };

  // const getSelectedCatData = (data) => {
  //   setData(data);

  //   setFormInputs(prev => ({
  //     ...prev,
  //     vendorCategory: [
  //       ...(prev.vendorCategory || []),
  //       data
  //     ]
  //   }));
  // };

  const getSelectedCatData = (data) => {
    // setData(data);

    setFormInputs((prev) => ({
      ...prev,
      vendorCategory: [...(prev.vendorCategory || []), ...data],
    }));
  };

  const onInputChange = ({ target: { name, value: rawValue } }) => {
    const errors = {};
    // Postal codes are stored upper-case (e.g. "SW1A 1AA")
    const value = name === "cityPostalCode" ? rawValue.toUpperCase() : rawValue;
    setFormInputs((formInputs) => ({ ...formInputs, [name]: value }));

    validateName(name === "organisationName" ? value : "")
      ? (errors.organisationName = "")
      : (errors.organisationName = message.SPECIAL_CHAR_SUPPLIER_NAME);
    validateEmail(name === "email" ? value : "")
      ? (errors.email = "")
      : (errors.email = message.VALID_MAIL_ID);
    validateEmail(name === "alternateEmailId" ? value : "")
      ? (errors.alternateEmailId = "")
      : (errors.alternateEmailId = message.VALID_ALTERNATE_MAIL_ID);
    validateContactNumber(name === "contactNumber" ? value : "")
      ? (errors.contactNumber = "")
      : (errors.contactNumber = message.VALID_CONTACT_NUMBER);
    validateContactNumber(name === "alternateContactNumber" ? value : "")
      ? (errors.alternateContactNumber = "")
      : (errors.alternateContactNumber =
          message.VALID_ALTERNATE_CONTACT_NUMBER);
    validateTextArea(name === "purposeJustification" ? value : "")
      ? (errors.purposeJustification = "")
      : (errors.purposeJustification = message.VALID_PURPOSE_JUSTIFICATION);
    validatePostalCodeForCountry(
      name === "cityPostalCode" ? value : "",
      countryCodeOf(formInputs.country, formInputs.countryCode),
    )
      ? (errors.cityPostalCode = "")
      : (errors.cityPostalCode = message.VALID_POSTAL_CODE);
    validateName(name === "contactfirstName" ? value : "")
      ? (errors.contactfirstName = "")
      : (errors.contactfirstName = message.VALID_CONTACT_FIRST_NAME);
    validateName(name === "contactlastName" ? value : "")
      ? (errors.contactlastName = "")
      : (errors.contactlastName = message.VALID_CONTACT_LAST_NAME);

    setValidation((prev) => ({
      ...prev,
      [name]: value === "" ? "" : errors[name] || "",
    }));
    // console.log("onInputChange => formInputs", formInputs);
  };

  const handleCheckValidation = async (
    { target: { name, value } },
    documentId,
  ) => {
    const errors = {};
    let obj = {};
    if (value) {
      if (name === "organisationName") {
        obj = {
          queryName: "ValidateSupplierName",
          payload: { validate: value.trim() },
        };
        await ItemService.checkValidation(obj).then((item) => {
          // console.log(">> item", item);
          !item || item.status === 200
            ? (errors.organisationName = "")
            : (errors.organisationName = message.EXIStS_SUPPLIER_NAME);
        });
        setValidation((prev) => ({
          ...prev,
          [name]: errors[name] || "",
        }));
      }
      if (name === "email") {
        if (validateEmail(value)) {
          obj = { queryName: "ValidateEmail", payload: { validate: value } };
          await ItemService.checkValidation(obj).then((item) => {
            // console.log(">> item", item);
            !item || item.status === 200
              ? (errors.email = "")
              : (errors.email = message.EXIStS_MAIL_ID);
          });
          setValidation((prev) => ({
            ...prev,
            [name]: errors[name] || "",
          }));
        }
      }
      if (name === "contactNumber") {
        if (validateContactNumber(value)) {
          obj = { queryName: "ValidateContactNumber", validate: value };
          await ItemService.checkValidation(obj).then((item) => {
            // console.log(">> item", item);
            !item || item.status === 200
              ? (errors.contactNumber = "")
              : (errors.contactNumber = message.EXIStS_CONTACT_NUMBER);
          });
          setValidation((prev) => ({
            ...prev,
            [name]: errors[name] || "",
          }));
        }
      }
      if (name === "documentNumber") {
        if (value) {
          const doc = formInputs.documentTypeData?.find(
            (d) => d.id === documentId,
          );
          const docTypeCode = doc?.documentTypeCode;

          const queryNameMap = {
            100: "ValidateDocumentPAN",
            101: "ValidateDocumentGST",
            102: "ValidateDocumentMSME",
            105: "ValidateDocumentTradeLicense",
          };

          const queryName =
            queryNameMap[docTypeCode] || "ValidateDocumentNumber";
          obj = { queryName, payload: { validate: value } };
          // console.log("Document Number Validation: ", obj);
          await ItemService.checkValidation(obj).then((item) => {
            // console.log(">> item", item);
            !item || item.status === 200
              ? (errors.documentNumber = "")
              : (errors.documentNumber = message.EXIStS_DOCUMENT_NUMBER);
          });
          setValidation((prev) => ({
            ...prev,
            documentNumber: {
              ...(prev.documentNumber || {}),
              [documentId]: errors.documentNumber || "",
            },
          }));
        }
      }
    }
  };
  const handleCheckAddressValidation = async (e) => {
    const { name, value } = e.target;
    const updatedInputs = { ...formInputs, [name]: value };
    const { address, address2, cityPostalCode } = updatedInputs;

    // Only call API when all three fields are filled and the postal code is well-formed
    if (!address || !address2 || !cityPostalCode) return;
    if (
      !validatePostalCodeForCountry(
        cityPostalCode,
        countryCodeOf(formInputs.country, formInputs.countryCode),
      )
    )
      return;

    const combinedAddress = [address, address2, cityPostalCode]
      .filter(Boolean)
      .join(" ");

    const obj = {
      queryName: "ValidateAddressCombined",
      payload: { validate: combinedAddress },
    };
    await ItemService.checkValidation(obj).then((item) => {
      if (!item) return; // request failed - don't flag the address as a duplicate
      const exists = item.status !== 200;
      if (exists) {
        toast.error(message.EXIStS_ADDRESS, {
          duration: 4000,
          position: "top-right",
        });
      }
      // Only clear the "already exists" error; keep any other (e.g. format) error intact
      const next = (current) =>
        exists
          ? message.EXIStS_ADDRESS
          : current === message.EXIStS_ADDRESS
            ? ""
            : current;
      setValidation((prev) => ({
        ...prev,
        address: next(prev.address),
        address2: next(prev.address2),
        cityPostalCode: next(prev.cityPostalCode),
      }));
    });
  };

  const handleCheckValidationAlternet = async ({ target: { name, value } }) => {
    const errors = {};
    let obj = {};
    if (value) {
      if (name === "alternateEmailId") {
        if (validateEmail(value)) {
          obj = {
            queryName: "ValidateAlternateEmail",
            payload: { validate: value },
          };
          await ItemService.checkValidation(obj).then((item) => {
            // console.log(">> item", item);
            !item || item.status === 200
              ? (errors.alternateEmailId = "")
              : (errors.alternateEmailId = message.EXIStS_ALTERNATE_MAIL_ID);
          });
          setValidation((prev) => ({
            ...prev,
            [name]: errors[name] || "",
          }));
        }
      }
      if (name === "alternateContactNumber") {
        if (validateContactNumber(value)) {
          obj = {
            queryName: "ValidateAlternateContactNumber",
            payload: { validate: value },
          };
          await ItemService.checkValidation(obj).then((item) => {
            // console.log(">> item", item);
            !item || item.status === 200
              ? (errors.alternateContactNumber = "")
              : (errors.alternateContactNumber =
                  message.EXIStS_ALTERNATE_CONTACT_NUMBER);
          });
          setValidation((prev) => ({
            ...prev,
            [name]: errors[name] || "",
          }));
        }
      }
    }
  };

  const [disabled, setDisabled] = useState(false);

  const getChangedFields = (oldData, newData) => {
    if (!oldData) return {}; // Add this line

    const changes = {};
    Object.keys(newData).forEach((key) => {
      // if (JSON.stringify(oldData[key]) !== JSON.stringify(newData[key])) {
      //   changes[key] = newData[key];
      // }

      if (!isEqual(oldData[key], newData[key])) {
        changes[key] = newData[key];
      }
    });
    return changes;
  };

  useEffect(() => {
    dispatch(getSupplierCategorySelection()); // getSupplierCategorySelection store
    getBankMasterData(); // Load Bank Details
    // Master data is loaded once, in loadDraft below
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (!getDropdownData) return;

    // ComboboxField also calls getvalue when it mounts (form open, newly added project).
    // Those events carry no selected item (status: false) and must not overwrite form
    // values. This replaces the old "ignore everything for 500ms after mount" workaround,
    // which also dropped a real selection made in that window.
    if (!getDropdownData.status) return;

    // Ignore if this dropdown is for a nested array field
    // if (getDropdownData?.codeType === "documentType") {
    //   // Do nothing here – handled by array-specific callbacks
    //   return;
    // }

    if (getDropdownData?.textField === "documentType") {
      setFormInputs((prev) => ({
        ...prev,
        documentTypeData: prev.documentTypeData.map((doc) =>
          doc.id === getDropdownData.index
            ? {
                ...doc,
                documentType: getDropdownData.name || "",
                documentTypeCode: getDropdownData.code || "",
                documentTypeDesc: getDropdownData.description || "",
              }
            : doc,
        ),
      }));

      return;
    }

    // ==========================
    // Bank Key Selection
    // ==========================
    if (
      getDropdownData.textField === "bankKey" &&
      getDropdownData.index !== undefined
    ) {
      const selectedBank = getBankDetailsData.find(
        (bank) =>
          bank.bankKey === getDropdownData.code ||
          bank.name === getDropdownData.name,
      );

      if (!selectedBank) return;

      setFormInputs((prev) => {
        const bankDetails = [...prev.bankDetails];

        bankDetails[getDropdownData.index] = {
          ...bankDetails[getDropdownData.index],

          // bankKey holds the dropdown label (set by onChangeValue); store the real key too
          bankKeyCode: String(selectedBank.bankKey ?? ""),

          bankName: selectedBank.bankAccountName || "",

          bankCountry:
            selectedBank.bankCountryDescription ||
            selectedBank.bankCountryKey ||
            "",

          bankAddress: selectedBank.bankAddress || "",

          preferredCurrency: selectedBank.bankCurrency || "",

          // Pre-fill SWIFT from the bank master when it has one; user can still edit it
          swiftIfscCode:
            selectedBank.swiftCode ||
            bankDetails[getDropdownData.index]?.swiftIfscCode ||
            "",
        };

        return {
          ...prev,
          bankDetails,
        };
      });

      return;
    }

    if (
      getDropdownData.textField === "projectCountry" ||
      getDropdownData.textField === "projectState"
    ) {
      setFormInputs((prev) => ({
        ...prev,
        projectDetails: prev.projectDetails.map((project, idx) => {
          if (idx !== getDropdownData.index) return project;

          const updated = {
            ...project,
            [getDropdownData.textField]: getDropdownData.name || "",
            [getDropdownData.textCode]: getDropdownData.code || "",
            [getDropdownData.textDesc]: getDropdownData.description || "",
          };

          // A different project country invalidates the selected project state
          const countryChanged =
            getDropdownData.textField === "projectCountry" &&
            getDropdownData.codeType === "country" &&
            getDropdownData.code !==
              countryCodeOf(project.projectCountry, project.projectCountryCode);
          if (countryChanged) {
            updated.projectState = "";
            updated.projectStateCode = "";
            updated.projectStateDesc = "";
          }
          return updated;
        }),
      }));

      // The project's state list is loaded by the statesByCountry effect
      return;
    }

    // Any other row-level dropdown (e.g. bank "included on list?") is already stored in its
    // row by its own onChangeValue; writing it at the top level created stray fields in the DB
    // (e.g. top-level bankNotListed / swiftIfscCode).
    if (getDropdownData.index !== undefined) return;

    // Dropdowns without code/description props (e.g. Payments Term) must not
    // write an "undefined" key into formInputs
    const { textField, textCode, textDesc } = getDropdownData;
    setFormInputs((formInputs) => {
      const next = {
        ...formInputs,
        [textField]: getDropdownData?.name,
        ...(textCode ? { [textCode]: getDropdownData?.code } : {}),
        ...(textDesc ? { [textDesc]: getDropdownData?.description } : {}),
      };
      // A different company country invalidates the selected state
      const countryChanged =
        textField === "country" &&
        getDropdownData?.codeType === "country" &&
        getDropdownData?.code !==
          countryCodeOf(formInputs.country, formInputs.countryCode);
      if (countryChanged) {
        next.state = "";
        next.stateCode = "";
        next.stateDesc = "";
      }
      return next;
    });
    // The state list for the new country is loaded by the statesByCountry effect

    // Postal code rules depend on the country: re-check the code already entered.
    // Only the format error is added/cleared; an "address already exists" error is kept.
    if (textField === "country") {
      const postal = formInputs.cityPostalCode;
      setValidation((prev) => ({
        ...prev,
        cityPostalCode:
          postal && !validatePostalCodeForCountry(postal, getDropdownData?.code)
            ? message.VALID_POSTAL_CODE
            : prev.cityPostalCode === message.VALID_POSTAL_CODE
              ? ""
              : prev.cityPostalCode,
      }));
    }

    setValidation((prev) => ({
      ...prev,
      [getDropdownData?.textField]: "",
    }));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [getDropdownData]);

  // console.log(">> formInputs", formInputs);

  // Datatables

  // useEffect(() => {
  //   console.log('Use Effect 4')
  //   if (!getDropdownData) return;
  //   if (getDropdownData?.codeType === "documentType") return; // nested arrays

  //   const fieldName = getDropdownData?.textField;
  //   const newValue = getDropdownData?.name;

  //   // ✅ avoid updating if value hasn't changed
  //   if (formInputs[fieldName] === newValue) return;

  //   setFormInputs(prev => ({
  //     ...prev,
  //     [fieldName]: newValue,
  //     [getDropdownData?.textCode]: getDropdownData?.code,
  //     [getDropdownData?.textDesc]: getDropdownData?.description,
  //   }));

  //   if (getDropdownData?.codeType === "country") {
  //     getStateData(getDropdownData?.code);
  //   }
  // }, [getDropdownData, formInputs]); // ✅ add formInputs to compare current value

  // useEffect(() => {
  //   if (!getDropdownData) return;
  //   if (getDropdownData?.codeType === "documentType") return;

  //   setFormInputs(prev => {

  //     if (prev[getDropdownData.textField] === getDropdownData.name) {
  //       return prev;
  //     }

  //     return {
  //       ...prev,
  //       [getDropdownData.textField]: getDropdownData.name,
  //       [getDropdownData.textCode]: getDropdownData.code,
  //       [getDropdownData.textDesc]: getDropdownData.description,
  //     };
  //   });

  // }, [getDropdownData]);

  // const fetchUsers = async (page) => {
  //   setLoading(true);
  //   // setData(selectedCategoryData);
  //   // formInputs.vendorCategory = selectedCategoryData;
  //   setFormInputs(prev => ({ ...prev, vendorCategory: selectedCategoryData }));
  //   setLoading(false);
  // };

  // useEffect(() => {
  //   fetchUsers(1); // fetch page 1 of users

  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [selectedCategoryData]);

  useEffect(() => {
    if (
      selectedCategoryData &&
      !isEqual(selectedCategoryData, formInputs.vendorCategory)
    ) {
      // setData(selectedCategoryData);
      setFormInputs((prev) => ({
        ...prev,
        vendorCategory: selectedCategoryData,
      }));
    }
    // eslint-disable-next-line
  }, [selectedCategoryData]);

  const columns = [
    {
      name: "Category Code",
      selector: (row) => row.vendorCategoryCode || "--",
      sortable: true,
      width: "250px",
    },
    {
      name: "Category Desc",
      selector: (row) => row.vendorCategoryText || "--",
      sortable: true,
      width: "280px",
    },
    {
      name: "Sub-Category Desc",
      selector: (row) => row.vendorSubCategoryText || "--",
      sortable: true,
      width: "200px",
    },
    {
      name: "Sub-Category Code",
      selector: (row) => row.vendorSubCategoryCode || "--",
      sortable: true,
      width: "200px",
    },
    {
      name: "Sub-Category Desc",
      selector: (row) => row.vendorSubCategoryLongText || "--",
      sortable: true,
      width: "400px",
    },
  ];

  const handleChange = ({ selectedRows }) => {
    // console.log(">> selectedRows ", selectedRows);
    if (selectedRows?.length > 0) {
      setDisabledRemove(false);
    } else {
      setDisabledRemove(true);
    }
    setSelectedData(selectedRows);
  };

  // const removeCategory = () => {
  //   const updatedInitialValue = data.filter(
  //     (item) => !getSelectedData.some((selected) => selected._id === item._id)
  //   );
  //   setData(updatedInitialValue);
  //   setDisabledRemove(true);
  // };

  // const removeCategory = () => {
  //   setFormInputs(prev => ({
  //     ...prev,
  //     vendorCategory: prev.vendorCategory.filter(
  //       item =>
  //         !getSelectedData.some(
  //           selected => selected._id === item._id
  //         )
  //     )
  //   }));

  //   setDisabledRemove(true);
  // };

  const removeCategory = () => {
    if (!getSelectedData?.length) return;

    setFormInputs((prev) => ({
      ...prev,
      vendorCategory: prev.vendorCategory.filter(
        (category) =>
          !getSelectedData.some(
            (selected) =>
              selected.vendorCategoryCode === category.vendorCategoryCode &&
              selected.vendorSubCategoryCode === category.vendorSubCategoryCode,
          ),
      ),
    }));

    setSelectedData([]);
    setDisabledRemove(true);
  };

  // SAVE
  const handleSave = async () => {
    // const requiredFields = [];
    // const errors = {};

    // const anyFieldNotEmpty = Object.values(validation).some(
    //   (value) => value !== null && value !== ""
    // );
    // if (anyFieldNotEmpty) {
    //   requiredFields.push(`${message.FILL_REQUIRED_FIELD}`);
    //   setErrorFields(requiredFields);
    //   setShowFailureModal(true);
    //   return;
    // }

    // if (!validateRequired(formInputs.organisationName)) {
    //   requiredFields.push(`${message.FILL_REQUIRED_FIELD}`);
    //   setErrorFields(requiredFields);
    //   setShowFailureModal(true);
    //   setValidation((prev) => ({
    //     ...prev,
    //     organisationName: message.FILL_REQUIRED_FIELD,
    //   }));
    //   return;
    // }

    // if (!validateName(formInputs.organisationName)) {
    //   requiredFields.push(`${message.SPECIAL_CHAR_SUPPLIER_NAME}`);
    //   setErrorFields(requiredFields);
    //   setShowFailureModal(true);
    //   setValidation((prev) => ({
    //     ...prev,
    //     organisationName: message.SPECIAL_CHAR_SUPPLIER_NAME,
    //   }));
    //   return;
    // }
    // if (!validateRequired(formInputs.address)) {
    //   requiredFields.push(`${message.FILL_REQUIRED_FIELD}`);
    //   setErrorFields(requiredFields);
    //   setShowFailureModal(true);
    //   setValidation((prev) => ({
    //     ...prev,
    //     address: message.FILL_REQUIRED_FIELD,
    //   }));
    //   return;
    // }
    // if (!validateRequired(formInputs.address2)) {
    //   requiredFields.push(`${message.FILL_REQUIRED_FIELD}`);
    //   setErrorFields(requiredFields);
    //   setShowFailureModal(true);
    //   setValidation((prev) => ({
    //     ...prev,
    //     address2: message.FILL_REQUIRED_FIELD,
    //   }));
    //   return;
    // }
    // if (!validateRequired(formInputs.city)) {
    //   requiredFields.push(`${message.FILL_REQUIRED_FIELD}`);
    //   setErrorFields(requiredFields);
    //   setShowFailureModal(true);
    //   setValidation((prev) => ({
    //     ...prev,
    //     city: message.FILL_REQUIRED_FIELD,
    //   }));
    //   return;
    // }
    // if (!validateRequired(formInputs.country)) {
    //   requiredFields.push(`${message.FILL_REQUIRED_FIELD}`);
    //   setErrorFields(requiredFields);
    //   setShowFailureModal(true);
    //   setValidation((prev) => ({
    //     ...prev,
    //     country: message.FILL_REQUIRED_FIELD,
    //   }));
    //   return;
    // }
    // if (!validateRequired(formInputs.state)) {
    //   requiredFields.push(`${message.FILL_REQUIRED_FIELD}`);
    //   setErrorFields(requiredFields);
    //   setShowFailureModal(true);
    //   setValidation((prev) => ({
    //     ...prev,
    //     state: message.FILL_REQUIRED_FIELD,
    //   }));
    //   return;
    // }
    // if (!validateRequired(formInputs.cityPostalCode)) {
    //   requiredFields.push(`${message.FILL_REQUIRED_FIELD}`);
    //   setErrorFields(requiredFields);
    //   setShowFailureModal(true);
    //   setValidation((prev) => ({
    //     ...prev,
    //     cityPostalCode: message.FILL_REQUIRED_FIELD,
    //   }));
    //   return;
    // }
    // if (!validPostalCode(formInputs.cityPostalCode)) {
    //   requiredFields.push(`${message.VALID_POSTAL_CODE}`);
    //   setErrorFields(requiredFields);
    //   setShowFailureModal(true);
    //   setValidation((prev) => ({
    //     ...prev,
    //     cityPostalCode: message.VALID_POSTAL_CODE,
    //   }));
    //   return;
    // }
    // if (!validateRequired(formInputs.contactPosition)) {
    //   requiredFields.push(`${message.FILL_REQUIRED_FIELD}`);
    //   setErrorFields(requiredFields);
    //   setShowFailureModal(true);
    //   setValidation((prev) => ({
    //     ...prev,
    //     contactPosition: message.FILL_REQUIRED_FIELD,
    //   }));
    //   return;
    // }
    // if (!validateRequired(formInputs.contactTitle)) {
    //   requiredFields.push(`${message.FILL_REQUIRED_FIELD}`);
    //   setErrorFields(requiredFields);
    //   setShowFailureModal(true);
    //   setValidation((prev) => ({
    //     ...prev,
    //     contactTitle: message.FILL_REQUIRED_FIELD,
    //   }));
    //   return;
    // }
    // if (!validateRequired(formInputs.contactfirstName)) {
    //   requiredFields.push(`${message.FILL_REQUIRED_FIELD}`);
    //   setErrorFields(requiredFields);
    //   setShowFailureModal(true);
    //   setValidation((prev) => ({
    //     ...prev,
    //     contactfirstName: message.FILL_REQUIRED_FIELD,
    //   }));
    //   return;
    // }
    // if (!validateName(formInputs.contactfirstName)) {
    //   requiredFields.push(`${message.VALID_CONTACT_FIRST_NAME}`);
    //   setErrorFields(requiredFields);
    //   setShowFailureModal(true);
    //   setValidation((prev) => ({
    //     ...prev,
    //     contactfirstName: message.VALID_CONTACT_FIRST_NAME,
    //   }));
    //   return;
    // }
    // if (!validateRequired(formInputs.contactlastName)) {
    //   requiredFields.push(`${message.FILL_REQUIRED_FIELD}`);
    //   setErrorFields(requiredFields);
    //   setShowFailureModal(true);
    //   setValidation((prev) => ({
    //     ...prev,
    //     contactlastName: message.FILL_REQUIRED_FIELD,
    //   }));
    //   return;
    // }
    // if (!validateName(formInputs.contactlastName)) {
    //   requiredFields.push(`${message.VALID_CONTACT_LAST_NAME}`);
    //   setErrorFields(requiredFields);
    //   setShowFailureModal(true);
    //   setValidation((prev) => ({
    //     ...prev,
    //     contactlastName: message.VALID_CONTACT_LAST_NAME,
    //   }));
    //   return;
    // }
    // if (!validateRequired(formInputs.email)) {
    //   requiredFields.push(`${message.FILL_REQUIRED_FIELD}`);
    //   setErrorFields(requiredFields);
    //   setShowFailureModal(true);
    //   setValidation((prev) => ({
    //     ...prev,
    //     email: message.FILL_REQUIRED_FIELD,
    //   }));
    //   return;
    // }
    // if (!validateEmail(formInputs.email)) {
    //   requiredFields.push(`${message.VALID_MAIL_ID}`);
    //   setErrorFields(requiredFields);
    //   setShowFailureModal(true);
    //   setValidation((prev) => ({
    //     ...prev,
    //     email: message.VALID_MAIL_ID,
    //   }));
    //   return;
    // }
    // if (!validateRequired(formInputs.contactNumber)) {
    //   requiredFields.push(`${message.FILL_REQUIRED_FIELD}`);
    //   setErrorFields(requiredFields);
    //   setShowFailureModal(true);
    //   setValidation((prev) => ({
    //     ...prev,
    //     contactNumber: message.FILL_REQUIRED_FIELD,
    //   }));
    //   return;
    // }
    // if (!validateContactNumber(formInputs.contactNumber)) {
    //   requiredFields.push(`${message.VALID_CONTACT_NUMBER}`);
    //   setErrorFields(requiredFields);
    //   setShowFailureModal(true);
    //   setValidation((prev) => ({
    //     ...prev,
    //     contactNumber: message.VALID_CONTACT_NUMBER,
    //   }));
    //   return;
    // }
    // if (formInputs.alternateEmailId === formInputs.email) {
    //   requiredFields.push(`${message.ALTERNATE_MAIL_ID}`);
    //   setErrorFields(requiredFields);
    //   setShowFailureModal(true);
    //   setValidation((prev) => ({
    //     ...prev,
    //     alternateEmailId: message.ALTERNATE_MAIL_ID,
    //   }));
    //   return;
    // }
    // if (formInputs.alternateContactNumber === formInputs.contactNumber) {
    //   requiredFields.push(`${message.ALTERNATE_CONTACT_NUMBER}`);
    //   setErrorFields(requiredFields);
    //   setShowFailureModal(true);
    //   setValidation((prev) => ({
    //     ...prev,
    //     alternateContactNumber: message.ALTERNATE_CONTACT_NUMBER,
    //   }));
    //   return;
    // }
    // if (!validateRequired(formInputs.ISOCertification)) {
    //   requiredFields.push(`${message.FILL_REQUIRED_FIELD}`);
    //   setErrorFields(requiredFields);
    //   setShowFailureModal(true);
    //   setValidation((prev) => ({
    //     ...prev,
    //     ISOCertification: message.FILL_REQUIRED_FIELD,
    //   }));
    //   return;
    // }
    // if (!validateRequired(formInputs.CompanyBrochure)) {
    //   requiredFields.push(`${message.FILL_REQUIRED_FIELD}`);
    //   setErrorFields(requiredFields);
    //   setShowFailureModal(true);
    //   setValidation((prev) => ({
    //     ...prev,
    //     CompanyBrochure: message.FILL_REQUIRED_FIELD,
    //   }));
    //   return;
    // }
    // if (!validateRequired(formInputs.supplierType)) {
    //   requiredFields.push(`${message.FILL_REQUIRED_FIELD}`);
    //   setErrorFields(requiredFields);
    //   setShowFailureModal(true);
    //   setValidation((prev) => ({
    //     ...prev,
    //     supplierType: message.FILL_REQUIRED_FIELD,
    //   }));
    //   return;
    // }
    // if (!validateRequired(formInputs.purposeJustification)) {
    //   requiredFields.push(`${message.FILL_REQUIRED_FIELD}`);
    //   setErrorFields(requiredFields);
    //   setShowFailureModal(true);
    //   setValidation((prev) => ({
    //     ...prev,
    //     purposeJustification: message.FILL_REQUIRED_FIELD,
    //   }));
    //   return;
    // }
    // if (!validateTextArea(formInputs.purposeJustification)) {
    //   requiredFields.push(`${message.VALID_PURPOSE_JUSTIFICATION}`);
    //   setErrorFields(requiredFields);
    //   setShowFailureModal(true);
    //   setValidation((prev) => ({
    //     ...prev,
    //     purposeJustification: message.VALID_PURPOSE_JUSTIFICATION,
    //   }));
    //   return;
    // }
    const requiredFields = [];

    // Primary Data
    if (!formInputs.organisationName) {
      requiredFields.push("Supplier Name is required");
      setValidation((prev) => ({
        ...prev,
        organisationName: message.FILL_REQUIRED_FIELD,
      }));
    }
    if (!formInputs.address) {
      requiredFields.push("Address Line 1 is required");
      setValidation((prev) => ({
        ...prev,
        address: message.FILL_REQUIRED_FIELD,
      }));
    }
    if (!formInputs.address2) {
      requiredFields.push("Address Line 2 is required");
      setValidation((prev) => ({
        ...prev,
        address2: message.FILL_REQUIRED_FIELD,
      }));
    }
    if (!formInputs.city) {
      requiredFields.push("City is required");
      setValidation((prev) => ({ ...prev, city: message.FILL_REQUIRED_FIELD }));
    }
    if (!formInputs.country) {
      requiredFields.push("Country is required");
      setValidation((prev) => ({
        ...prev,
        country: message.FILL_REQUIRED_FIELD,
      }));
    }
    if (!formInputs.state) {
      requiredFields.push("State is required");
      setValidation((prev) => ({
        ...prev,
        state: message.FILL_REQUIRED_FIELD,
      }));
    }
    if (!formInputs.cityPostalCode) {
      requiredFields.push("Postal Code is required");
      setValidation((prev) => ({
        ...prev,
        cityPostalCode: message.FILL_REQUIRED_FIELD,
      }));
    } else if (
      !validatePostalCodeForCountry(
        formInputs.cityPostalCode,
        countryCodeOf(formInputs.country, formInputs.countryCode),
      )
    ) {
      requiredFields.push(message.VALID_POSTAL_CODE);
      setValidation((prev) => ({
        ...prev,
        cityPostalCode: message.VALID_POSTAL_CODE,
      }));
    }

    // Contact Person
    if (!formInputs.contactPosition) {
      requiredFields.push("Job Title is required");
      setValidation((prev) => ({
        ...prev,
        contactPosition: message.FILL_REQUIRED_FIELD,
      }));
    }
    if (!formInputs.contactTitle) {
      requiredFields.push("Contact Title is required");
      setValidation((prev) => ({
        ...prev,
        contactTitle: message.FILL_REQUIRED_FIELD,
      }));
    }
    if (!formInputs.contactfirstName) {
      requiredFields.push("Contact First Name is required");
      setValidation((prev) => ({
        ...prev,
        contactfirstName: message.FILL_REQUIRED_FIELD,
      }));
    }
    if (!formInputs.contactlastName) {
      requiredFields.push("Contact Last Name is required");
      setValidation((prev) => ({
        ...prev,
        contactlastName: message.FILL_REQUIRED_FIELD,
      }));
    }
    if (!formInputs.email) {
      requiredFields.push("Contact Email is required");
      setValidation((prev) => ({
        ...prev,
        email: message.FILL_REQUIRED_FIELD,
      }));
    }
    if (!formInputs.contactNumber) {
      requiredFields.push("Contact Number is required");
      setValidation((prev) => ({
        ...prev,
        contactNumber: message.FILL_REQUIRED_FIELD,
      }));
    }

    // More Information
    // if (!formInputs.CompanyBrochure) {
    //   requiredFields.push("Website/Logo and Company Brochure is required");
    //   setValidation((prev) => ({ ...prev, CompanyBrochure: message.FILL_REQUIRED_FIELD }));
    // }
    if (!formInputs.supplierType) {
      requiredFields.push("Supplier Type is required");
      setValidation((prev) => ({
        ...prev,
        supplierType: message.FILL_REQUIRED_FIELD,
      }));
    }
    if (!formInputs.paymentsTerm) {
      requiredFields.push("Payments Term is required");
      setValidation((prev) => ({
        ...prev,
        paymentsTerm: message.FILL_REQUIRED_FIELD,
      }));
    }

    // Financial Info (bank details) is optional, but every bank entry that is added must be
    // complete - one toast per bank listing everything it is missing, and the fields turn red
    (formInputs.bankDetails || []).forEach((bank, i) => {
      const problems = getBankProblems(bank);
      if (problems.length > 0) {
        requiredFields.push(
          `Bank ${i + 1}: ${problems.map((p) => p.text).join(", ")}`,
        );
      }
    });
    setCheckedBanks((formInputs.bankDetails || []).map(() => true));

    // Declaration
    // if (!formInputs.conflictInterestDeclaration) {
    //   requiredFields.push("Conflict of Interest Declaration is required");
    // }
    // if (!formInputs.vendorCodeOfConduct) {
    //   requiredFields.push("Vendor Code of Conduct is required");
    // }

    // If any required fields missing - show toast and stop
    if (requiredFields.length > 0) {
      requiredFields.forEach((msg) => {
        toast.error(msg, {
          duration: 3000,
          position: "top-right",
        });
      });
      return;
    }

    // Block submission while any field still shows an error (format or "already exists"),
    // and show that field's actual message
    const fieldError = Object.values(validation).find(
      (msg) => typeof msg === "string" && msg !== "",
    );
    if (fieldError) {
      toast.error(fieldError, {
        duration: 4000,
        position: "top-right",
      });
      return;
    }

    // Check documentNumber exists errors
    if (
      validation.documentNumber &&
      typeof validation.documentNumber === "object"
    ) {
      const hasDocError = Object.values(validation.documentNumber).some(
        (v) => v !== "",
      );
      if (hasDocError) {
        toast.error(
          "Document Number already exists. Please use a different document number.",
          {
            duration: 4000,
            position: "top-right",
          },
        );
        return;
      }
    }

    // formInputs.firstName = formInputs.organisationName;
    // setFormInputs(prev => ({ ...prev, firstName: prev.organisationName }))
    // formInputs.initiatorName = "Self";
    // setFormInputs(prev => ({ ...prev, initiatorName: "Self" }));
    // formInputs.initiator = "Self";
    // setFormInputs(prev => ({ ...prev, initiator: "Self" }));

    // initiatedBy: "Admin",
    // initiator: "Admin",

    const toastId = toast.loading("Loading...", {
      position: "top-right",
    });
    let obj = {
      data: {
        ...formInputs,
        firstName: formInputs.organisationName,
        initiatorName: "Self",
        initiator: "Self",
        contactDetails: [
          {
            lastName: formInputs.contactlastName,
            firstName: formInputs.contactfirstName,
            contactEmail: formInputs.email,
            contactTitle: formInputs.contactTitle,
            contactNumber: formInputs.contactNumber,
            contactPosition: formInputs.contactPosition,
          },
        ],
        draftData: {
          draftUserId: userInfo?.userId,
          draftDocumentNumber: draftData?.documentNumber,
          draftType: draftData?.draftType,
        },
      },
    };

    setDisabled(true);
    setDisabledStatus(true);
    await ItemService.addSelfSupplier(obj).then((item) => {
      if (item?.status === 200) {
        modalData.successMsg = item?.message;
        // toast.success(item?.message || "Deleted successfully", {
        //   duration: 3000,
        //   position: "top-right",
        // });

        setModalInfo(modalData);
        onSuccessfullyRegistered();
        // Update response value in Redux Store
        dispatch(getSupplierList()); // event store
      } else {
        toast.error("Please try again !!", {
          duration: 4000,
          position: "top-right",
        });
      }
    });

    toast.dismiss(toastId);
    setDisabled(false);
    setDisabledStatus(false);
  };

  //Load Master Data - all code types are fetched in parallel
  const getMasterData = async () => {
    const load = (codeType, setter) =>
      ItemService.getMasterDataSelf({ codeType }).then((item) => {
        if (item?.status === 200) {
          setter(item?.data);
        } else {
          setter([]);
          console.log(">> Error: Loading getMasterDataSelf", codeType);
        }
      });

    await Promise.all([
      load("title", setTitle),
      load("country", (data) => setCountry(sortByLabel(data))),
      load("companyCode", setCompanyCode),
      load("purchaseOrganisation", setPurchaseOrg),
      load("jobtitle", setcontactPosition),
      load("SupplierType", setSupplierType),
      load("documentType", setdocumentType),
    ]);
  };

  // Load the state list for every country in use (company address + each project).
  // Covers country selection, drafts opened with a country, and newly added projects.
  // Each country is fetched once; results are stored under their own code, so a slow
  // response can never overwrite the list of a different country.
  const countryCodesInUse = [
    countryCodeOf(formInputs.country, formInputs.countryCode),
    ...(formInputs.projectDetails || []).map((p) =>
      countryCodeOf(p.projectCountry, p.projectCountryCode),
    ),
  ].filter(Boolean);
  const countryCodesKey = [...new Set(countryCodesInUse)].sort().join(",");

  useEffect(() => {
    if (!countryCodesKey) return;
    countryCodesKey.split(",").forEach((code) => {
      if (requestedStateCountries.current.has(code)) return;
      requestedStateCountries.current.add(code);

      ItemService.getMasterDataSelf({ codeType: "region", code }).then(
        (item) => {
          if (item?.status === 200) {
            setStatesByCountry((prev) => ({
              ...prev,
              [code]: sortByLabel(item?.data),
            }));
          } else {
            // Allow a retry the next time the set of selected countries changes
            requestedStateCountries.current.delete(code);
            console.log(">> Error: Loading getMasterDataSelf region", code);
          }
        },
      );
    });
  }, [countryCodesKey]);
  const getBankMasterData = async () => {
    await ItemService.getBankMasterData().then((item) => {
      // console.log(">> item!", item);
      // Bank master list lives only in getBankDetailsData (dropdown source);
      // keeping it out of formInputs stops it being sent with the draft/submit payloads
      if (item?.status === 200) {
        setBankDetailsData(item?.data || []);
      } else {
        setBankDetailsData([]);
        console.log(">> Error: Loading getBankMasterData");
      }
    });
  };

  const hideFailureModal = () => {
    setShowFailureModal(false);
  };

  /* ---------------------project details block-------- */

  const addProjectDetails = () => {
    setFormInputs((prev) => {
      const newProjectObj = {
        ...newProject,
        projectCode: nextId + 1,
        projectCodeDesc: `PROJECT_${nextId + 1}`,
        // Ensure nested arrays are deep copied
        getProjectContactPerson: [{ ...newProject.getProjectContactPerson[0] }],
        getProjectCertifications: [
          { ...newProject.getProjectCertifications[0] },
        ],
        getLocations: [],
      };
      // Assign unique IDs inside nested objects (optional, but good practice)
      newProjectObj.getProjectContactPerson[0].id = Date.now();
      newProjectObj.getProjectCertifications[0].id = Date.now();

      return {
        ...prev,
        projectDetails: [...prev.projectDetails, newProjectObj],
      };
    });
    setNextId((prev) => prev + 1);
  };

  const removeProjectDetails = (indexToRemove) => {
    setFormInputs((prev) => ({
      ...prev,
      projectDetails: prev.projectDetails.filter(
        (_, idx) => idx !== indexToRemove,
      ),
    }));
  };

  const handleProjectInputChange = (value, index, fieldName) => {
    // console.log("Handle Project Input Changes : ", value, '-', index, '-', fieldName)
    setFormInputs((prev) => ({
      ...prev,
      projectDetails: prev.projectDetails.map((item, idx) =>
        idx === index ? { ...item, [fieldName]: value } : item,
      ),
    }));
  };

  /* --------------------- Contact Person Inside Project Details -------- */

  //Add Projects

  const addProjectContactPerson = (projectIndex) => {
    const newContactPerson = {
      id: Date.now(),
      projectContactPosition: "",
      projectContactTitle: "",
      projectContactName: "",
      projectContactNumber: "",
      projectContactEmail: "",
    };
    setFormInputs((prev) => {
      const updatedProjects = [...prev.projectDetails];
      updatedProjects[projectIndex] = {
        ...updatedProjects[projectIndex],
        getProjectContactPerson: [
          ...updatedProjects[projectIndex].getProjectContactPerson,
          newContactPerson,
        ],
      };
      return { ...prev, projectDetails: updatedProjects };
    });
  };

  //Delete Project

  const deleteProjectContactPerson = (projectIndex, contactId) => {
    setFormInputs((prev) => {
      const updatedProjects = [...prev.projectDetails];
      updatedProjects[projectIndex] = {
        ...updatedProjects[projectIndex],
        getProjectContactPerson: updatedProjects[
          projectIndex
        ].getProjectContactPerson.filter((contact) => contact.id !== contactId),
      };
      return { ...prev, projectDetails: updatedProjects };
    });
  };

  const handleChangeProjectContacts = (
    projectIndex,
    contactId,
    fieldName,
    value,
  ) => {
    setFormInputs((prev) => {
      const updatedProjects = [...prev.projectDetails];
      updatedProjects[projectIndex] = {
        ...updatedProjects[projectIndex],
        getProjectContactPerson: updatedProjects[
          projectIndex
        ].getProjectContactPerson.map((contact) =>
          contact.id === contactId
            ? { ...contact, [fieldName]: value }
            : contact,
        ),
      };
      return { ...prev, projectDetails: updatedProjects };
    });
  };

  //Dropdown
  const handleChangeProjectContactsDropdown = (
    projectIndex,
    contactId,
    fieldName,
    selectedObj,
  ) => {
    if (fieldName === "documentType" && formInputs.projectDetails) {
      setFormInputs((prev) => {
        const updatedProjects = [...prev.projectDetails];
        updatedProjects[projectIndex] = {
          ...updatedProjects[projectIndex],
          getProjectCertifications: updatedProjects[
            projectIndex
          ].getProjectCertifications.map((contact) =>
            contact.id === contactId
              ? { ...contact, [fieldName]: selectedObj?.name || "" }
              : contact,
          ),
        };
        return { ...prev, projectDetails: updatedProjects };
      });
    }
    setFormInputs((prev) => {
      const updatedProjects = [...prev.projectDetails];
      updatedProjects[projectIndex] = {
        ...updatedProjects[projectIndex],
        getProjectContactPerson: updatedProjects[
          projectIndex
        ].getProjectContactPerson.map((contact) =>
          contact.id === contactId
            ? { ...contact, [fieldName]: selectedObj?.name || "" }
            : contact,
        ),
      };
      return { ...prev, projectDetails: updatedProjects };
    });
  };

  /* ---------------------project Certifications  -------- */

  const deleteProjectCertification = (projectIndex, certId) => {
    setFormInputs((prev) => {
      const updatedProjects = [...prev.projectDetails];
      updatedProjects[projectIndex] = {
        ...updatedProjects[projectIndex],
        getProjectCertifications: updatedProjects[
          projectIndex
        ].getProjectCertifications.filter((cert) => cert.id !== certId),
      };
      return { ...prev, projectDetails: updatedProjects };
    });
  };

  const addProjectCertification = (projectIndex) => {
    const newCert = {
      id: Date.now(),
      name: `Document ${formInputs.projectDetails[projectIndex]?.getProjectCertifications.length + 1}`,
      documentType: "",
      certificateCode: "",
      stageDocument: "",
    };
    setFormInputs((prev) => {
      const updatedProjects = [...prev.projectDetails];
      updatedProjects[projectIndex] = {
        ...updatedProjects[projectIndex],
        getProjectCertifications: [
          ...updatedProjects[projectIndex].getProjectCertifications,
          newCert,
        ],
      };
      return { ...prev, projectDetails: updatedProjects };
    });
  };

  const onSuccessUploadProjectStageDocument = (
    projectIndex,
    certId,
    fieldName,
    attachmentId,
  ) => {
    setFormInputs((prev) => {
      const updatedProjects = [...prev.projectDetails];
      updatedProjects[projectIndex] = {
        ...updatedProjects[projectIndex],
        getProjectCertifications: updatedProjects[
          projectIndex
        ].getProjectCertifications.map((cert) =>
          cert.id === certId ? { ...cert, [fieldName]: attachmentId } : cert,
        ),
      };
      return { ...prev, projectDetails: updatedProjects };
    });
  };

  // file attachmetns
  const onSuccessUploadfiles = (data) => {
    setFormInputs((prevData) => ({
      ...prevData,
      [data.fieldName]: data.attachmentId,
    }));
  };

  const deleteDocumentType = (id) => {
    setFormInputs((prev) => ({
      ...prev,
      documentTypeData: prev.documentTypeData.filter((doc) => doc.id !== id),
    }));
  };

  const addDocumentType = () => {
    setFormInputs((prev) => ({
      ...prev,
      documentTypeData: [
        ...prev.documentTypeData,
        {
          id: Date.now(),
          name: `Document ${prev.documentTypeData.length + 1}`,
          documentType: "",
          documentNumber: "",
          issueDate: "",
          issuingAuthority: "",
        },
      ],
    }));
  };

  const handleInputChange = (id, fieldName, value) => {
    setFormInputs((prev) => ({
      ...prev,
      documentTypeData: prev.documentTypeData.map((doc) =>
        doc.id === id ? { ...doc, [fieldName]: value } : doc,
      ),
    }));
  };

  const handleDocumentTypeChange = (id, selected) => {
    setFormInputs((prev) => ({
      ...prev,
      documentTypeData: prev.documentTypeData.map((doc) =>
        doc.id === id
          ? {
              ...doc,
              documentType: selected.name,
              documentTypeCode: selected.code,
              documentTypeDesc: selected.description,
            }
          : doc,
      ),
    }));
  };

  useEffect(() => {
    if (draftData && previousFormInputsRef.current === null) {
      previousFormInputsRef.current = JSON.parse(JSON.stringify(formInputs));
    }
    // eslint-disable-next-line
  }, [draftData]);

  let dropdownOption = [
    {
      id: "1",
      name: "Yes",
    },
    {
      id: "2",
      name: "No",
    },
  ];

  const bankInfoInitialData = {
    bankNotListed: "",
    bankAccountNumber: "",
    bankKey: "",
    bankKeyCode: "",
    iban: "",
    bankName: "",
    bankCountry: "",
    bankAddress: "",
    AccountHolderName: "",
    bankCompanyletterhead: "",
    bankConfirmationLetter: "",
    chipsCode: "",
    swiftIfscCode: "",
    bankInfoTemplate: "",
    preferredCurrency: "",

    turnover1: "",
    turnover2: "",
    turnover3: "",
    turnover1Atch: "",
    turnover2Atch: "",
    turnover3Atch: "",
    financialDocNote: "",
    financialUploadDocument: "",
  };

  const onSuccessUploadBankDocumentType = (data, index) => {
    setFormInputs((prev) => {
      const newBankDetails = [...prev.bankDetails];
      newBankDetails[index] = {
        ...newBankDetails[index],
        [data.fieldName]: data.attachmentId,
      };
      return { ...prev, bankDetails: newBankDetails };
    });
  };

  const onSuccessUploadDocumentType = (data) => {
    setFormInputs((prev) => ({
      ...prev,
      documentTypeData: prev.documentTypeData.map((doc) =>
        doc.id === data.fieldId
          ? { ...doc, [data.fieldName]: data.attachmentId }
          : doc,
      ),
    }));
  };

  const addBankForm = () => {
    setFormInputs((prev) => ({
      ...prev,
      bankDetails: [...prev.bankDetails, bankInfoInitialData],
    }));
  };

  const removeBankForm = (indexToRemove) => {
    setFormInputs((prev) => ({
      ...prev,
      bankDetails: prev.bankDetails.filter((_, idx) => idx !== indexToRemove),
    }));
    // Keep the highlight flags lined up with the remaining entries
    setCheckedBanks((prev) => prev.filter((_, idx) => idx !== indexToRemove));
    setBlurredBankFields((prev) =>
      prev.filter((_, idx) => idx !== indexToRemove),
    );
  };

  // Leaving a bank field with a value marks it, so a wrong value is shown in red under the
  // field (replaces the old pop-up, which also opened when the field was left empty)
  const onBankFieldBlur = (index, key, value) => {
    if (!value) return;
    setBlurredBankFields((prev) => {
      const next = [...prev];
      next[index] = { ...next[index], [key]: true };
      return next;
    });
  };

  // Errors to show for one bank entry: everything once Create was clicked, otherwise only the
  // format errors of fields the user has already left with a value
  const visibleBankErrors = (bank, index) => {
    const errors = getBankFieldErrors(bank);
    if (checkedBanks[index]) return errors;
    return Object.fromEntries(
      Object.entries(errors).filter(
        ([field]) => blurredBankFields[index]?.[field] && bank[field],
      ),
    );
  };

  const handleChangeBankInfo = (index, key, value) => {
    setFormInputs((prev) => {
      const newBankDetails = [...prev.bankDetails];
      const current = newBankDetails[index] || {};
      newBankDetails[index] = { ...current, [key]: value };

      // "Is the Company bank included on list?": Yes = pick a BankID (details auto-filled),
      // No = type the bank details. Clear what belonged to the other answer.
      if (key === "bankNotListed") {
        const typedDetails = {
          bankName: "",
          bankCountry: "",
          bankAddress: "",
          preferredCurrency: "",
        };
        if (
          value === "No" &&
          (current.bankKey || current.bankNotListed === "Yes")
        ) {
          Object.assign(newBankDetails[index], {
            bankKey: "",
            bankKeyCode: "",
            ...typedDetails,
          });
        } else if (value === "Yes" && current.bankNotListed === "No") {
          Object.assign(newBankDetails[index], typedDetails);
        }
      }
      return { ...prev, bankDetails: newBankDetails };
    });
  };

  useEffect(() => {
    draftDataRef.current = draftData;
  }, [draftData]);

  const updateDraft = async () => {
    // if (!previousFormInputsRef.current || !draftData) {
    if (!previousFormInputsRef.current || !draftDataRef.current) {
      console.warn(
        "Skipping draft update: previousFormInputsRef.current is null Baseline missing",
      );
      return;
    }
    // Create new object instead of mutating state
    const payloadData = {
      ...formInputs,
      // contactDetails: [objContactDetails],
    };

    const changedData = getChangedFields(
      previousFormInputsRef.current,
      payloadData,
    );

    if (Object.keys(changedData).length === 0) {
      // console.log("No changes detected, skipping draft update.");
      return;
    }

    // --- NEW: Calculate progress and add to changed data ---
    const newProgress = calculateDraftProgress(formInputs);
    changedData.completionPercentage = newProgress;

    try {
      const response = await ItemService.updateDraft(
        draftData?.documentNumber,
        userInfo?.userId,
        draftData?.draftType,
        changedData,
      );

      if (response.status === 200) {
        previousFormInputsRef.current = JSON.parse(JSON.stringify(payloadData));
      }
    } catch (error) {
      console.error("Update draft failed:", error);
    }
  };

  useEffect(() => {
    if (isFirstAutoSave.current) {
      isFirstAutoSave.current = false;
      // Store the initial form inputs state right away
      previousFormInputsRef.current = JSON.parse(JSON.stringify(formInputs));
      return;
    }

    // if (isUpdatingDraft.current) return;
    // if (!draftData || !previousFormInputsRef.current) return;
    if (
      isLoadingDraft ||
      !draftDataRef.current ||
      !previousFormInputsRef.current
    )
      return;

    // --- NEW: Deep check if form data actually changed ---
    // This prevents updates if the child component re-emitted the exact same values on mount
    const hasDataChanged =
      JSON.stringify(previousFormInputsRef.current) !==
      JSON.stringify(formInputs);
    if (!hasDataChanged) {
      // console.log(
      //   "Form inputs haven't structurally changed. Skipping API call.",
      // );
      return;
    }

    const timer = setTimeout(async () => {
      try {
        // isUpdatingDraft.current = true;
        await updateDraft();
        // Update the reference after a successful save
        previousFormInputsRef.current = JSON.parse(JSON.stringify(formInputs));
      } catch (error) {
        console.error(error);
      }
    }, 2000);

    return () => clearTimeout(timer);
    // eslint-disable-next-line
  }, [formInputs, isLoadingDraft]);

  const mapDraftToFormInputs = (draftData) => {
    const empty = createEmptyFormInputs();

    return {
      ...empty,
      // email: draftData.contactDetails?.[0]?.contactEmail || draftData.email || "",
      email: draftData.email || "",
      organisationName: draftData.organisationName || "",
      firstName: draftData.firstName || "",
      version: draftData.version || "v0",
      status: draftData.status || "Non Invited",
      // contactfirstName: draftData.contactDetails?.[0]?.firstName || "",
      // contactlastName: draftData.contactDetails?.[0]?.lastName || "",
      // contactNumber: draftData.contactDetails?.[0]?.contactNumber || "",

      contactfirstName: draftData?.contactfirstName || "",
      contactlastName: draftData?.contactlastName || "",
      contactNumber: draftData?.contactNumber || "",

      alternateEmailId: draftData.alternateEmailId || "",
      alternateContactNumber: draftData.alternateContactNumber || "",
      category: draftData.category || "VENDOR",
      vendorCode: draftData.vendorCode || "",
      mou: draftData.mou || "",
      mouAttachment: draftData.mouAttachment || "",
      mouDate: draftData.mouDate || "",
      descriptionMou: draftData.descriptionMou || "",
      mouamendent: draftData.mouamendent || "",
      qms: draftData.qms || "",
      supplierType: draftData.supplierType || "",
      supplierTypeCode: draftData.supplierTypeCode || "",
      supplierTypeDesc: draftData.supplierTypeDesc || "",
      paymentsTerm: draftData.paymentsTerm || "",
      // Fall back to the new-form defaults: autosave only stores fields the user changed,
      // so these are usually absent from the draft
      accountGroup: draftData.accountGroup || empty.accountGroup,
      companyName: draftData.companyName || "",
      address: draftData.address || "",
      address2: draftData.address2 || "",
      city: draftData.city || "",
      state: draftData.state || "",
      stateCode: draftData.stateCode || "",
      stateDesc: draftData.stateDesc || "",
      country: draftData.country || "",
      countryCode: draftData.countryCode || "",
      countryDesc: draftData.countryDesc || "",
      contactTitle: draftData?.contactTitle || "",
      contactTitleCode: draftData?.contactTitleCode || "",
      contactTitleDesc: draftData?.contactTitleDesc || "",
      contactPosition: draftData?.contactPosition || "",
      contactPositionCode: draftData?.contactPositionCode || "",
      contactPositionDesc: draftData?.contactPositionDesc || "",
      cityPostalCode: draftData.cityPostalCode || "",
      ISOCertification: draftData.ISOCertification || "",
      ISOCertificationCode: draftData.ISOCertificationCode || "",
      ISOCertificationDesc: draftData.ISOCertificationDesc || "",
      ICVCertificate: draftData.ICVCertificate || "",
      CompanyBrochure: draftData.CompanyBrochure || "",
      companyBrochure1: draftData.companyBrochure1 || "",
      purposeJustification: draftData.purposeJustification || "",
      natureOfBusiness: draftData.natureOfBusiness || "",
      purchaseOrg: draftData.purchaseOrg || "",
      companyCode: draftData.companyCode || "",
      vendorCategory: draftData.vendorCategory || [],
      roles: draftData.roles?.length ? draftData.roles : empty.roles,
      subCategory: draftData.subCategory?.length
        ? draftData.subCategory
        : empty.subCategory,
      contactDetails: draftData.contactDetails || [],
      // Include all nested data
      bankDetails: draftData.bankDetails || [],
      documentTypeData: draftData.documentTypeData || [],
      projectDetails: draftData.projectDetails || [],
      conflictInterestDeclaration: draftData.conflictInterestDeclaration || "",
      vendorCodeOfConduct: draftData.vendorCodeOfConduct || "",
      antiBriberyPolicy: draftData.antiBriberyPolicy,

      completionPercentage: draftData.completionPercentage || 0,
    };
  };

  useEffect(() => {
    if (!getdocumentType.length || !formInputs.documentTypeData.length) return;

    const updatedDocs = formInputs.documentTypeData.map((doc) => {
      // If documentType is already a name, skip
      if (getdocumentType.some((opt) => opt.name === doc.documentType))
        return doc;

      // Otherwise, try to find by code or description
      const matched = getdocumentType.find(
        (opt) =>
          opt.code === doc.documentType || opt.description === doc.documentType,
      );
      if (matched) {
        return {
          ...doc,
          documentType: matched.name,
          documentTypeCode: matched.code,
          documentTypeDesc: matched.description,
        };
      }
      return doc;
    });

    if (
      JSON.stringify(updatedDocs) !==
      JSON.stringify(formInputs.documentTypeData)
    ) {
      setFormInputs((prev) => ({ ...prev, documentTypeData: updatedDocs }));
    }
  }, [getdocumentType, formInputs.documentTypeData]);

  // Handlers for loading a specific draft by ID
  const handleSelectDraft = async (draftNumber) => {
    try {
      const res = await ItemService.getDraftById(
        draftNumber,
        "SUPPLIER",
        userInfo?.userId,
      );
      if (res?.success && res?.data) {
        const draft = res.data;
        const mappedData = mapDraftToFormInputs(draft);
        setDraftData(draft);
        draftDataRef.current = draft;
        setFormInputs(mappedData);
        previousFormInputsRef.current = JSON.parse(JSON.stringify(mappedData));
        // Also update any nested state (like vendorCategory, bankDetails, documentTypeData, projectDetails) if needed
      } else {
        toast.error("Failed to load draft.");
      }
    } catch (error) {
      console.error("handleSelectDraft error", error);
      toast.error("Error loading draft.");
    }
  };

  // Helper to create new draft and set empty form
  const createNewDraftAndProceed = async () => {
    try {
      const createRes = await ItemService.createDraft(
        userInfo?.userId,
        "SUPPLIER",
      );
      if (createRes?.success && createRes?.data) {
        const emptyData = createEmptyFormInputs();
        const draft = createRes.data;
        setDraftData(draft);
        draftDataRef.current = draft;
        setFormInputs(emptyData);
        previousFormInputsRef.current = JSON.parse(JSON.stringify(emptyData));
      } else {
        // If creation fails, use empty form without draft
        const emptyData = createEmptyFormInputs();
        setFormInputs(emptyData);
        previousFormInputsRef.current = JSON.parse(JSON.stringify(emptyData));
      }
    } catch (error) {
      console.error("createNewDraftAndProceed error", error);
      const emptyData = createEmptyFormInputs();
      setFormInputs(emptyData);
      previousFormInputsRef.current = JSON.parse(JSON.stringify(emptyData));
    }
  };

  //this is old
  useEffect(() => {
    // const loadDraft = async () => {
    //   setIsLoadingDraft(true);

    //   const res = await ItemService.getDraftInitial(userInfo?.userId, "SUPPLIER");
    //   if (res.success && res.exists && res.data) {
    //     const mappedData = mapDraftToFormInputs(res.data);
    //     setDraftData(res.data);
    //     setFormInputs(mappedData);
    //     previousFormInputsRef.current = await JSON.parse(JSON.stringify(mappedData));
    //     await console.log('FORM DATA AFTER LOADING DRAFT: ', formInputs)
    //     await setIsLoadingDraft(false);
    //   }
    //   else if (res.success && !res.exists) {
    //     // After creation, reload (or set empty form)
    //     const emptyData = createEmptyFormInputs();
    //     setFormInputs(emptyData);
    //     previousFormInputsRef.current = JSON.parse(JSON.stringify(emptyData));
    //     const response = await ItemService.createDraft(userInfo?.userId, "SUPPLIER");

    //     if (response.success && response.data) {
    //       setDraftData(response.data)
    //     }

    //     setIsLoadingDraft(false);
    //   }
    // };

    const loadDraft = async () => {
      setIsLoadingDraft(true);

      // Open the requested draft, otherwise create a new one
      const draftPromise = draftIdParam
        ? handleSelectDraft(draftIdParam).catch((error) => {
            console.error("loadDraftById error", error);
            toast.error("Error loading draft.");
            navigate(-1); // or go to list page
          })
        : createNewDraftAndProceed();

      // Master data and draft load in parallel; the loader stays up until both are done
      try {
        await Promise.all([getMasterData(), draftPromise]);
      } finally {
        setIsLoadingDraft(false);
      }
    };

    // loadDraft();
    if (userInfo?.userId) loadDraft();
    // eslint-disable-next-line
  }, [userInfo?.userId, draftIdParam, newDraftParam]);

  //this is new
  // useEffect(() => {
  //   const loadDraft = async () => {
  //     setIsLoadingDraft(true);

  //     try {
  //       const res = await ItemService.getDraftInitial(
  //         userInfo?.userId,
  //         "SUPPLIER"
  //       );

  //       if (res?.success && res?.exists && res?.data) {
  //         const mappedData = mapDraftToFormInputs(res.data);

  //         previousFormInputsRef.current = JSON.parse(
  //           JSON.stringify(mappedData)
  //         );

  //         setDraftData(res.data);
  //         setFormInputs(mappedData);

  //         console.log("FORM DATA AFTER LOADING DRAFT:", mappedData);
  //       } else if (res?.success && !res?.exists) {
  //         const emptyData = createEmptyFormInputs();

  //         setFormInputs(emptyData);

  //         previousFormInputsRef.current = JSON.parse(
  //           JSON.stringify(emptyData)
  //         );

  //         const response = await ItemService.createDraft(
  //           userInfo?.userId,
  //           "SUPPLIER"
  //         );

  //         if (response?.success && response?.data) {
  //           setDraftData(response.data);
  //         }
  //       }
  //     } catch (error) {
  //       console.error(
  //         "getDraftInitial API Error:",
  //         error?.response?.status || error?.message || error
  //       );

  //       // Initialize empty form so page continues to work
  //       const emptyData = createEmptyFormInputs();

  //       setFormInputs(emptyData);

  //       previousFormInputsRef.current = JSON.parse(
  //         JSON.stringify(emptyData)
  //       );
  //     } finally {
  //       setIsLoadingDraft(false);
  //     }
  //   };

  //   if (userInfo?.userId) {
  //     loadDraft();
  //   }

  // // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [userInfo?.userId]);

  if (isLoadingDraft) {
    return (
      <main className="dashboard main" id="main">
        <Layout />
        {/* <div className="text-center mt-5">Loading draft...</div> */}
        <Loader isLoading={isLoadingDraft} className={"text-center"} />
      </main>
    );
  }

  return (
    <main className="dashboard commTopButtonRightLeftPadding">
      <Row className="justify-center">
        <Col xs={12} md={12} className="rightSide mr-4 ml-6">
          <div className="rightSideInner PageCommonCSS">
            {/* <h2 className="mainTitle">Self Supplier Registration Form</h2>
            <p className="subText">Register as a new Supplier or Sub-Contractor with our Company</p>
            <hr /> */}

            <Row className="mb-4 align-items-center">
              <Col xs={12} md={6} className="d-flex justify-content-start">
                <button className="btnBack" onClick={() => navigate(-1)}>
                  <i className="bi bi-chevron-double-left"></i> Go Back
                </button>
              </Col>

              <Col
                xs={12}
                md={{ span: 2, offset: 4 }}
                lg={{ span: 2, offset: 4 }}
                className="d-flex justify-content-end gap-2"
              >
                <button
                  className="btnTable"
                  onClick={handleSave}
                  disabled={disabled}
                >
                  <i className="bi bi-check-circle"></i> Create
                </button>
              </Col>
            </Row>

            <div className="accordion mb-4" id="accordionExample">
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <Row className="accordion-button">
                    <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                      <i
                        className={`bi ${
                          isCardVisible ? "bi-chevron-right" : "bi-chevron-down"
                        }`}
                        onClick={toggleCardVisibility}
                      ></i>
                    </Col>
                    <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                      <span className="iconLogo">PD</span>
                    </Col>
                    <Col xs={8} md={9} lg={9}>
                      <span className="headerTitle">Primary Data</span>
                      <span className="subHeaderTitle">General Details</span>
                    </Col>
                  </Row>
                </h2>

                <div
                  className={`accordion-collapse collapse show ${
                    isCardVisible ? "visible" : ""
                  }`}
                >
                  <div className="accordion-body">
                    <Row className="pt-2 pb-4">
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Supplier Name"
                          // extraLabel="As per the trade license"
                          name="organisationName"
                          placeholder=""
                          value={formInputs.organisationName || ""}
                          onChange={onInputChange}
                          required={true}
                          onBlur={handleCheckValidation}
                          error={validation.organisationName}
                        />
                      </Col>

                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label=" Address Line 1 / Street"
                          name="address"
                          placeholder=""
                          value={formInputs.address || ""}
                          onChange={onInputChange}
                          onBlur={handleCheckAddressValidation}
                          error={validation.address}
                          required={true}
                        />
                      </Col>

                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Address Line 2"
                          name="address2"
                          placeholder=""
                          value={formInputs.address2 || ""}
                          onChange={onInputChange}
                          onBlur={handleCheckAddressValidation}
                          error={validation.address2}
                          required={true}
                        />
                      </Col>

                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="City"
                          name="city"
                          placeholder=""
                          value={formInputs.city || ""}
                          onChange={onInputChange}
                          error={validation.city}
                          required={true}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <ComboboxField
                          label="Country"
                          placeholder=""
                          data={getCountry}
                          id="country"
                          iconClassName="dropdownIcon"
                          name="country"
                          code="countryCode"
                          description="countryDesc"
                          setValue={formInputs.country}
                          getvalue={setDropdownData}
                          error={validation.country}
                          required={true}
                        />
                      </Col>

                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        {/* <ComboboxField
                          // Remount per country so the dropdown forgets the previous
                          // country's pick (otherwise re-picking the same state is ignored)
                          key={`state-${countryCodeOf(formInputs.country, formInputs.countryCode)}`}
                          fireOnMount={false}
                          label="State"
                          placeholder=""
                          data={
                            statesByCountry[
                            countryCodeOf(formInputs.country, formInputs.countryCode)
                            ] || []
                          }
                          id="state"
                          iconClassName="dropdownIcon"
                          name="state"
                          code="stateCode"
                          description="stateDesc"
                          setValue={formInputs.state}
                          getvalue={setDropdownData}
                          error={validation.state}
                          required={true}
                        /> */}
                        <ComboboxField
                          key={`state-${countryCodeOf(formInputs.country, formInputs.countryCode)}`}
                          fireOnMount={false}
                          label="State"
                          placeholder={
                            !formInputs.country
                              ? "Select Country first"
                              : "Select State"
                          }
                          data={
                            statesByCountry[
                              countryCodeOf(
                                formInputs.country,
                                formInputs.countryCode,
                              )
                            ] || []
                          }
                          id="state"
                          iconClassName="dropdownIcon"
                          name="state"
                          code="stateCode"
                          description="stateDesc"
                          setValue={formInputs.state}
                          getvalue={setDropdownData}
                          error={validation.state}
                          required={true}
                          disabled={!formInputs.country || getDisabledStatus}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        {/* <InputField
                          className="inputBox"
                          label="Postal Code/PO Box"
                          name="cityPostalCode"
                          placeholder=""
                          value={formInputs.cityPostalCode || ""}
                          onChange={onInputChange}
                          onBlur={handleCheckAddressValidation}
                          error={validation.cityPostalCode}
                          maxLength={10}
                          extraLabel={message.VALID_POSTAL_CODE}
                          required={true}
                        /> */}
                        <InputField
                          className="inputBox"
                          label="Postal Code/PO Box"
                          name="cityPostalCode"
                          placeholder={
                            !formInputs.country ? "Select Country first" : ""
                          }
                          disabled={!formInputs.country}
                          value={formInputs.cityPostalCode || ""}
                          onChange={onInputChange}
                          onBlur={handleCheckAddressValidation}
                          error={validation.cityPostalCode}
                          maxLength={10}
                          extraLabel={message.VALID_POSTAL_CODE}
                          required={true}
                        />
                      </Col>
                    </Row>
                  </div>
                </div>
              </div>
            </div>
            <div className="accordion mb-4" id="accordionExample">
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <Row className="accordion-button">
                    <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                      <i
                        className={`bi ${
                          isCardVisible2
                            ? "bi-chevron-right"
                            : "bi-chevron-down"
                        }`}
                        onClick={toggleCardVisibility2}
                      ></i>
                    </Col>
                    <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                      <span className="iconLogo">CP</span>
                    </Col>
                    <Col xs={8} md={9} lg={9}>
                      <span className="headerTitle">Contact Person</span>
                      <span className="subHeaderTitle">
                        Contact Person Details
                      </span>
                    </Col>
                  </Row>
                </h2>

                <div
                  className={`accordion-collapse collapse show ${
                    isCardVisible2 ? "visible" : ""
                  }`}
                >
                  <div className="accordion-body">
                    <Row className="pt-2 pb-4">
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <ComboboxField
                          label="Job Title"
                          placeholder=""
                          data={getcontactPosition}
                          id="contactPosition"
                          iconClassName="dropdownIcon"
                          name="contactPosition"
                          code="contactPositionCode"
                          description="contactPositionDesc"
                          setValue={formInputs.contactPosition}
                          error={validation.contactPosition}
                          getvalue={setDropdownData}
                          required={true}
                        />
                      </Col>

                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <ComboboxField
                          label="Title"
                          placeholder=""
                          data={getTitle}
                          id="contactTitle"
                          iconClassName="dropdownIcon"
                          name="contactTitle"
                          code="contactTitleCode"
                          description="contactTitleDesc"
                          setValue={formInputs.contactTitle}
                          error={validation.contactTitle}
                          getvalue={setDropdownData}
                          required={true}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="First Name"
                          name="contactfirstName"
                          placeholder=""
                          value={formInputs.contactfirstName || ""}
                          onChange={onInputChange}
                          error={validation.contactfirstName}
                          required={true}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Last Name"
                          name="contactlastName"
                          placeholder=""
                          value={formInputs.contactlastName || ""}
                          onChange={onInputChange}
                          error={validation.contactlastName}
                          required={true}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Email"
                          name="email"
                          placeholder=""
                          value={formInputs.email || ""}
                          onChange={onInputChange}
                          onBlur={handleCheckValidation}
                          required={true}
                          error={validation.email}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Number"
                          name="contactNumber"
                          placeholder=""
                          value={formInputs.contactNumber || ""}
                          onChange={onInputChange}
                          onBlur={handleCheckValidation}
                          required={true}
                          error={validation.contactNumber}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Alternate Number"
                          name="alternateContactNumber"
                          placeholder=""
                          value={formInputs.alternateContactNumber || ""}
                          onChange={onInputChange}
                          onBlur={handleCheckValidationAlternet}
                          error={validation.alternateContactNumber}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Alternate Email"
                          name="alternateEmailId"
                          placeholder=""
                          value={formInputs.alternateEmailId || ""}
                          onChange={onInputChange}
                          onBlur={handleCheckValidationAlternet}
                          // error={validation.alternateContactNumber}
                          error={validation.alternateEmailId}
                        />
                      </Col>
                    </Row>
                  </div>
                </div>
              </div>
            </div>
            <div className="accordion mb-4" id="accordionExample">
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <Row className="accordion-button">
                    <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                      <i
                        className={`bi ${
                          isCardVisible3
                            ? "bi-chevron-right"
                            : "bi-chevron-down"
                        }`}
                        onClick={toggleCardVisibility3}
                      ></i>
                    </Col>
                    <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                      <span className="iconLogo">AI</span>
                    </Col>
                    <Col xs={8} md={9} lg={9}>
                      <span className="headerTitle">More Information</span>
                      <span className="subHeaderTitle">
                        Additional Information
                      </span>
                    </Col>
                  </Row>
                </h2>

                <div
                  className={`accordion-collapse collapse show ${
                    isCardVisible3 ? "visible" : ""
                  }`}
                >
                  <div className="accordion-body">
                    <Row className="pt-2 pb-4">
                      {/* <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <ComboboxField
                          label="Do you have ISO Certification?"
                          extraLabel="Certification?"
                          name="ISOCertification"
                          code="ISOCertificationCode"
                          description="ISOCertificationDesc"
                          data={dropdownOption}
                          id="ISOCertification"
                          iconClassName="dropdownIcon"
                          onChange={setDropdownData}
                          setValue={formInputs.ISOCertification}
                          error={validation.ISOCertification}
                          getvalue={setDropdownData}
                          required={true}
                        // className="dropdownOption"
                        />

                      </Col> */}

                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Website/Logo and Company Brochure"
                          extraLabel="Web site URL /Logo  and Company Brochure Attachment"
                          name="CompanyBrochure"
                          placeholder=""
                          value={formInputs.CompanyBrochure || ""}
                          onChange={onInputChange}
                          disabled={false}
                          error={validation.CompanyBrochure}
                          // required={true}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <ComboboxField
                          label="Supplier Type"
                          placeholder=""
                          data={getSupplierType}
                          id="suppliertype"
                          iconClassName="dropdownIcon"
                          name="supplierType"
                          code="supplierTypeCode"
                          description="supplierTypeDesc"
                          setValue={formInputs.supplierType}
                          getvalue={setDropdownData}
                          error={validation.supplierType}
                          required={true}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <ComboboxField
                          // key={`paymentsTerm-${formInputs.paymentsTerm}`}
                          label="Payments Term"
                          placeholder=""
                          data={PaymentTermsOptions}
                          id="paymentsTerm"
                          iconClassName="dropdownIcon"
                          name="paymentsTerm"
                          // code="supplierTypeCode"
                          // description="supplierTypeDesc"
                          setValue={formInputs.paymentsTerm}
                          getvalue={setDropdownData}
                          error={validation.paymentsTerm}
                          required={true}
                        />
                      </Col>
                      {formInputs.supplierTypeDesc === "Factory" &&
                        formInputs.supplierTypeCode === "S02" && (
                          <>
                            <Col
                              xs={12}
                              md={4}
                              lg={4}
                              className="commTopButtonRightLeftPadding"
                            >
                              <ComboboxField
                                className="inputBox"
                                label="QMS"
                                name="qms"
                                placeholder=""
                                iconClassName="dropdownIcon"
                                data={qmsOptions}
                                setValue={formInputs.qms}
                                onChange={onInputChange}
                                getvalue={setDropdownData}
                                // onBlur={handleCheckValidationAlternet}
                                // error={validation.alternateContactNumber}
                                error={validation.qms}
                              />
                            </Col>
                          </>
                        )}
                      <Row>
                        <Col
                          xs={12}
                          md={4}
                          lg={4}
                          className="commTopButtonRightLeftPadding"
                        >
                          <TextAreaField
                            className="inputBox"
                            label="Purpose/Justification: Please outline the advantages our company would gain by registering your organization as a supplier"
                            extraLabel="Please explain benefits Our Company would get from registering your company?"
                            type="text"
                            name="purposeJustification"
                            id="purposeJustification"
                            value={formInputs.purposeJustification || ""}
                            onChange={onInputChange}
                            error={validation.purposeJustification}
                            // className="dropdownOption"
                          />
                        </Col>
                        <Col
                          xs={12}
                          md={4}
                          lg={4}
                          className="commTopButtonRightLeftPadding"
                        >
                          <TextAreaField
                            className="inputBox"
                            label="Nature of business"
                            // extraLabel="Web site URL /Logo  and Company Brochure Attachment"
                            name="natureOfBusiness"
                            placeholder=""
                            value={formInputs.natureOfBusiness || ""}
                            onChange={onInputChange}
                            disabled={false}
                            error={validation.natureOfBusiness}
                            // required={true}
                          />
                        </Col>
                        <Col
                          xs={12}
                          md={3}
                          lg={3}
                          className="commTopButtonRightLeftPadding"
                        >
                          <FileUploadComponent
                            name="companyBrochure1"
                            label="Company Brochure"
                            allowedTypes={[
                              "image/png",
                              "image/jpeg",
                              "application/pdf",
                            ]}
                            multiple={true} // Change to `false` for single file selection
                            onSuccessUpload={onSuccessUploadfiles}
                            value={formInputs.companyBrochure1 || ""}
                          />
                        </Col>
                        <Col
                          xs={12}
                          md={1}
                          lg={1}
                          className="commTopButtonRightLeftPadding m-0 p-0 d-flex justify-content-center align-items-center"
                        >
                          {(formInputs?.companyBrochure1 && (
                            <img
                              src="assets/img/newIcons/attached-file.png"
                              className="mt-1 attachmentIcon"
                              alt="attachments"
                              onClick={() =>
                                handleViewFile(formInputs?.companyBrochure1)
                              }
                            />
                          )) ||
                            "--"}
                        </Col>
                      </Row>
                      {/* <Col
                        xs={12}
                        md={3}
                        lg={3}
                        className="commTopButtonRightLeftPadding"
                      >
                        <FileUploadComponent
                          name="iSOCertification"
                          label="ISO Certification"
                          allowedTypes={[
                            "image/png",
                            "image/jpeg",
                            "application/pdf",
                          ]}
                          multiple={true} // Change to `false` for single file selection
                          onSuccessUpload={onSuccessUploadfiles}
                          value={formInputs.iSOCertification || ""}
                        />
                      </Col> */}
                      {/* <Col
                        xs={12}
                        md={1}
                        lg={1}
                        className="commTopButtonRightLeftPadding m-0 p-0 d-flex justify-content-center align-items-center"
                      >
                        {(formInputs?.iSOCertification && (
                          <img
                            src="assets/img/newIcons/attached-file.png"
                            className="mt-1 attachmentIcon"
                            alt="attachments"
                            onClick={() =>
                              handleViewFile(
                                formInputs?.iSOCertification
                              )
                            }
                          />
                        )) ||
                          "--"}
                      </Col> */}
                    </Row>
                  </div>
                </div>
              </div>
            </div>

            <div className="accordion mb-4" id="accordionExample">
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <Row className="accordion-button">
                    <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                      <i
                        className={`bi ${
                          isCardVisible4
                            ? "bi-chevron-right"
                            : "bi-chevron-down"
                        }`}
                        onClick={toggleCardVisibility4}
                      ></i>
                    </Col>
                    <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                      <span className="iconLogo">CS</span>
                    </Col>
                    <Col xs={8} md={6} lg={6}>
                      <span className="headerTitle">
                        Category Selection
                      </span>
                      {/* <span className="subHeaderTitle">
                        Select Required Group
                      </span> */}
                    </Col>
                    <Col xs={4} md={2} lg={2} className="btnSpaceInMobile">
                      <button
                        className="btnTable"
                        onClick={() => categorySelection()}
                      >
                        <i className="bi bi-plus-lg"></i> Add
                      </button>
                    </Col>

                    <Col xs={5} md={2} lg={2} className="btnSpaceInMobile">
                      <button
                        className="btnTable"
                        onClick={() => removeCategory()}
                        disabled={getDisabledRemove}
                      >
                        <i className="bi bi-trash3"></i> Remove Category
                      </button>
                    </Col>
                  </Row>
                </h2>

                <div
                  className={`accordion-collapse collapse show ${
                    isCardVisible4 ? "visible" : ""
                  }`}
                >
                  <div className="accordion-body">
                    <Row className="pt-2 pb-4">
                      <Col xs={12} md={12} lg={12}>
                        <DataTable
                          title=""
                          columns={columns}
                          // data={data}
                          data={formInputs.vendorCategory}
                          // progressPending={loading}
                          paginationRowsPerPageOptions={Constants.ROW_PER_PAGE}
                          pagination
                          // paginationServer
                          // paginationTotalRows={totalRows}
                          // onChangeRowsPerPage={handlePerRowsChange}
                          // onChangePage={handlePageChange}
                          selectableRows
                          onSelectedRowsChange={handleChange}
                        />
                      </Col>
                    </Row>
                  </div>
                </div>
              </div>
            </div>

            {/* customer Document Type isCardVisible2 */}
            <div className="accordion mb-4" id="accordionExample">
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <Row className="accordion-button">
                    <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                      <i
                        className={`bi ${
                          isCardVisible3
                            ? "bi-chevron-right"
                            : "bi-chevron-down"
                        }`}
                        onClick={toggleCardVisibility3}
                      ></i>
                    </Col>
                    <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                      <span className="iconLogo">DT</span>
                    </Col>
                    <Col xs={4} md={9} lg={9}>
                      <span className="headerTitle"> Document Type</span>
                      {/* <span className="subHeaderTitle">Document Type</span> */}
                    </Col>
                    <Col xs={4} md={2} lg={2}>
                      <div className="d-flex justify-content-end  p-2 me-3">
                        <button
                          type="button"
                          className="btnTable"
                          onClick={addDocumentType}
                        >
                          <i className="bi bi-plus-lg"></i> Add
                        </button>
                      </div>
                    </Col>
                  </Row>
                </h2>
                <div
                  // id="acc"
                  className={`accordion-collapse collapse show ${
                    isCardVisible3 ? "visible" : ""
                  }`}
                >
                  <div className="accordion-body">
                    <Row>
                      <Col xs={12} md={12} lg={12}>
                        <div className="accordion-body">
                          <div className="d-flex-column justify-content-center">
                            <Row>
                              <Col xs={12}>
                                <div className="accordion-body">
                                  <div className="d-flex-column justify-content-center">
                                    <Row className="pt-4 d-none d-lg-flex ">
                                      <Col xs={12} md={4} lg={2}>
                                        <p className="fs-6 fw-medium d-flex ms-4">
                                          Document Type
                                        </p>
                                      </Col>
                                      <Col xs={12} md={4} lg={2}>
                                        <p className="fs-6 fw-medium d-flex ms-4">
                                          Document Number
                                        </p>
                                      </Col>
                                      <Col xs={12} md={4} lg={2}>
                                        <p className="fs-6 fw-medium d-flex ms-4">
                                          Issue Date
                                        </p>
                                      </Col>
                                      <Col xs={12} md={4} lg={1}>
                                        <p className="fs-6 fw-medium d-flex ms-4">
                                          View Files
                                        </p>
                                      </Col>
                                      <Col xs={12} md={4} lg={2}>
                                        <p className="fs-6 fw-medium d-flex ms-4">
                                          Attachments
                                        </p>
                                      </Col>
                                      <Col xs={12} md={4} lg={2}>
                                        <p className="fs-6 fw-medium d-flex justify-content-center ms-4">
                                          Action
                                        </p>
                                      </Col>
                                    </Row>
                                    {formInputs.documentTypeData.map(
                                      (doc, index) => (
                                        <Row key={doc.id}>
                                          <Col xs={12}>
                                            <hr className="mx-4 my-0 text-color-black" />
                                          </Col>
                                          <Col
                                            xs={12}
                                            md={4}
                                            lg={2}
                                            className="commTopButtonRightLeftPadding"
                                          >
                                            <ComboboxField
                                              label=""
                                              placeholder="Document type"
                                              data={getdocumentType.filter(
                                                (opt) =>
                                                  !formInputs.documentTypeData.some(
                                                    (d) =>
                                                      d.id !== doc.id &&
                                                      d.documentTypeCode ===
                                                        opt.code,
                                                  ),
                                              )}
                                              // data={formInputs.documentTypeData}
                                              // data={formInputs.documentType}
                                              id="documentType"
                                              iconClassName="dropdownIcon"
                                              name="documentType"
                                              code="documentTypeCode"
                                              description="documentTypeDesc"
                                              // setValue={doc?.documentType}
                                              // setValue={
                                              //   getdocumentType?.find(
                                              //     item => item.name === doc?.documentType
                                              //   ) || null
                                              // }
                                              setValue={
                                                getdocumentType?.find(
                                                  (item) =>
                                                    item.name ===
                                                    doc?.documentType,
                                                ) || null
                                              }
                                              getvalue={setDropdownData}
                                              index={doc.id}
                                              // onChangeValue={handleInputChange}
                                              // onChangeValue={(selected) =>{
                                              //   handleInputChange(doc.id, "documentType", selected?.name || "")
                                              //   console.log('Document Type in Input: ', selected)
                                              // }
                                              // }
                                              // onChangeValue={(selected) => {
                                              //   // Directly update the specific document's type
                                              //   handleInputChange(doc.id, "documentType", selected?.value || "");
                                              // }}

                                              onChangeValue={(selected) =>
                                                handleDocumentTypeChange(
                                                  doc.id,
                                                  selected,
                                                )
                                              }
                                            />
                                          </Col>
                                          <Col
                                            xs={12}
                                            md={4}
                                            lg={2}
                                            className="commTopButtonRightLeftPadding"
                                          >
                                            <InputField
                                              className="inputBox"
                                              placeholder="Document Number"
                                              value={doc?.documentNumber}
                                              name="documentNumber"
                                              onChange={(e) => {
                                                handleInputChange(
                                                  doc.id,
                                                  "documentNumber",
                                                  e.target.value,
                                                );
                                                // console.log('Document Number: ', e.target.value)
                                              }}
                                              // onBlur={handleCheckValidation}
                                              onBlur={(e) =>
                                                handleCheckValidation(e, doc.id)
                                              }
                                              // error={validation.documentNumber}
                                              error={
                                                validation.documentNumber?.[
                                                  doc.id
                                                ]
                                              }
                                            />
                                          </Col>
                                          <Col
                                            xs={12}
                                            md={4}
                                            lg={2}
                                            className="commTopButtonRightLeftPadding"
                                          >
                                            <InputField
                                              className="inputBox"
                                              type="date"
                                              value={doc?.issueDate}
                                              onChange={(e) => {
                                                handleInputChange(
                                                  doc.id,
                                                  "issueDate",
                                                  e.target.value,
                                                );
                                              }}
                                            />
                                          </Col>
                                          <Col
                                            xs={12}
                                            md={4}
                                            lg={1}
                                            className="commTopButtonRightLeftPadding"
                                          >
                                            <div className="d-flex justify-content-center">
                                              {(doc.iSOCertification && (
                                                <img
                                                  src="assets/img/newIcons/attached-file.png"
                                                  className="mt-1 attachmentIcon"
                                                  alt="attachments"
                                                  onClick={() =>
                                                    handleViewFile(
                                                      doc.iSOCertification,
                                                    )
                                                  }
                                                />
                                              )) ||
                                                "--"}
                                            </div>
                                          </Col>
                                          <Col
                                            xs={12}
                                            md={4}
                                            lg={3}
                                            className="commTopButtonRightLeftPadding"
                                          >
                                            <FileUploadComponent
                                              id={doc.id}
                                              name="iSOCertification"
                                              label=""
                                              allowedTypes={[
                                                "image/png",
                                                "image/jpeg",
                                                "application/pdf",
                                              ]}
                                              multiple={true} // Change to `false` for single file selection
                                              required={true}
                                              onSuccessUpload={
                                                onSuccessUploadDocumentType
                                              }
                                              value={doc.iSOCertification || ""}
                                            />
                                          </Col>
                                          <Col
                                            xs={12}
                                            md={4}
                                            lg={1}
                                            className="commTopButtonRightLeftPadding"
                                          >
                                            <i
                                              onClick={() =>
                                                deleteDocumentType(doc.id)
                                              }
                                              className="bi bi-trash text-danger fs-4"
                                            />
                                          </Col>
                                        </Row>
                                      ),
                                    )}
                                  </div>
                                </div>
                              </Col>
                            </Row>
                          </div>
                        </div>
                      </Col>
                    </Row>
                  </div>
                </div>
              </div>
            </div>
            {/* 08 Banker Info*/}
            {/* */}
            <div className="accordion mb-4" id="accordionExample">
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <Row className="accordion-button">
                    <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                      <i
                        className={`bi ${isCardVisible8 ? "bi-chevron-right" : "bi-chevron-down"}`}
                        onClick={toggleCardVisibility8}
                      ></i>
                    </Col>
                    <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                      <span className="iconLogo">FI</span>
                    </Col>
                    <Col xs={12} md={8} lg={8}>
                      <span className="headerTitle">Financial Info</span>
                      <span className="subHeaderTitle">
                        Please include all the required financial data.
                      </span>
                    </Col>
                    <Col xs={4} md={2} lg={2} className="">
                      <button
                        className="btnTable"
                        onClick={() => addBankForm()}
                        disabled={getDisabledStatus}
                      >
                        <i className="bi bi-plus-lg"></i> Add Bank Info
                      </button>
                    </Col>
                    <Col xs={2} md={1} lg={1} className="">
                      <CommonFillter />
                    </Col>
                  </Row>
                </h2>

                <div
                  className={`accordion-collapse collapse show ${isCardVisible8 ? "visible" : ""}`}
                >
                  <div className="accordion-body">
                    {formInputs.bankDetails &&
                      formInputs.bankDetails?.map((item, index) => {
                        const bankErrors = visibleBankErrors(item, index);
                        return (
                          <div key={index}>
                            {/* ===== Section 1: Bank Information ===== */}
                            <Row className="pt-2 pb-2">
                              <Col
                                xs={12}
                                md={12}
                                lg={12}
                                className="commTopButtonRightLeftPadding"
                              >
                                <h6>Section {index + 1}: Bank Information</h6>
                                <span
                                  className="deleteIconAccordion"
                                  onClick={() => removeBankForm(index)}
                                >
                                  <i className="bi bi-x-circle"></i>
                                </span>
                              </Col>

                              <Col
                                xs={12}
                                md={4}
                                lg={4}
                                className="commTopButtonRightLeftPadding"
                              >
                                <ComboboxField2
                                  label="Is the Company bank included on list?"
                                  placeholder=""
                                  data={dropdownOption}
                                  id="bankNotListed"
                                  iconClassName="dropdownIcon"
                                  name="bankNotListed"
                                  setValue={item?.bankNotListed}
                                  value={item?.bankNotListed}
                                  getvalue={setDropdownData}
                                  index={index}
                                  onChangeValue={handleChangeBankInfo}
                                  // onChange={(e) => handleChangeBankInfo(index, "bankNotListed", e.target.value)}
                                  disabled={getDisabledStatus}
                                  required={true}
                                  error={bankErrors.bankNotListed}
                                />
                              </Col>

                              <Col
                                xs={12}
                                md={4}
                                lg={4}
                                className="commTopButtonRightLeftPadding"
                              >
                                <ComboboxField2
                                  label="BankID"
                                  placeholder=""
                                  data={getBankDetailsData}
                                  // data={formInputs.bankDetailsData}
                                  id="bankKey"
                                  iconClassName="dropdownIcon"
                                  name="bankKey"
                                  code="bankKeyCode"
                                  description="bankKeyDesc"
                                  setValue={item?.bankKey}
                                  value={item?.bankKey}
                                  getvalue={setDropdownData}
                                  index={index}
                                  onChangeValue={handleChangeBankInfo}
                                  // onChange={(e) => handleChangeBankInfo(index, "bankKey", e.target.value)}
                                  // Not applicable when the bank is not on the list
                                  disabled={
                                    getDisabledStatus ||
                                    item?.bankNotListed === "No"
                                  }
                                  required={item?.bankNotListed !== "No"}
                                  error={bankErrors.bankKey}
                                />
                              </Col>

                              <Col
                                xs={12}
                                md={4}
                                lg={4}
                                className="commTopButtonRightLeftPadding"
                              >
                                <InputField
                                  className="inputBox"
                                  label="Bank A/C Number"
                                  name="bankAccountNumber"
                                  placeholder=""
                                  value={item?.bankAccountNumber}
                                  index={index}
                                  // onChangeValue={handleChangeBankInfo}
                                  onChange={(e) =>
                                    handleChangeBankInfo(
                                      index,
                                      "bankAccountNumber",
                                      e.target.value,
                                    )
                                  }
                                  onBlur={(e) =>
                                    onBankFieldBlur(
                                      index,
                                      "bankAccountNumber",
                                      e.target.value,
                                    )
                                  }
                                  disabled={getDisabledStatus}
                                  maxLength={18}
                                  required={true}
                                  error={bankErrors.bankAccountNumber}
                                />
                              </Col>

                              <Col
                                xs={12}
                                md={4}
                                lg={4}
                                className="commTopButtonRightLeftPadding"
                              >
                                <InputField
                                  className="inputBox"
                                  label="Bank Name"
                                  name="bankName"
                                  placeholder=""
                                  value={item?.bankName || ""}
                                  onChange={(e) =>
                                    handleChangeBankInfo(
                                      index,
                                      "bankName",
                                      e.target.value,
                                    )
                                  }
                                  // Auto-filled from BankID; typed in when the bank is not on the list
                                  disabled={
                                    getDisabledStatus ||
                                    item?.bankNotListed !== "No"
                                  }
                                  required={item?.bankNotListed === "No"}
                                  error={bankErrors.bankName}
                                />
                              </Col>

                              <Col
                                xs={12}
                                md={4}
                                lg={4}
                                className="commTopButtonRightLeftPadding"
                              >
                                <InputField
                                  className="inputBox"
                                  label="Bank Country"
                                  name="bankCountry"
                                  placeholder=""
                                  value={item?.bankCountry || ""}
                                  onChange={(e) =>
                                    handleChangeBankInfo(
                                      index,
                                      "bankCountry",
                                      e.target.value,
                                    )
                                  }
                                  disabled={
                                    getDisabledStatus ||
                                    item?.bankNotListed !== "No"
                                  }
                                  required={item?.bankNotListed === "No"}
                                  error={bankErrors.bankCountry}
                                />
                              </Col>

                              <Col
                                xs={12}
                                md={4}
                                lg={4}
                                className="commTopButtonRightLeftPadding"
                              >
                                <InputField
                                  className="inputBox"
                                  label="Branch Address"
                                  name="bankAddress"
                                  placeholder=""
                                  value={item?.bankAddress || ""}
                                  onChange={(e) =>
                                    handleChangeBankInfo(
                                      index,
                                      "bankAddress",
                                      e.target.value,
                                    )
                                  }
                                  disabled={
                                    getDisabledStatus ||
                                    item?.bankNotListed !== "No"
                                  }
                                />
                              </Col>

                              <Col
                                xs={12}
                                md={4}
                                lg={4}
                                className="commTopButtonRightLeftPadding"
                              >
                                <InputField
                                  className="inputBox"
                                  label="Preferred Currency"
                                  name="preferredCurrency"
                                  placeholder=""
                                  // value={item?.bankCurrency}
                                  value={item?.preferredCurrency || ""}
                                  onChange={(e) =>
                                    handleChangeBankInfo(
                                      index,
                                      "preferredCurrency",
                                      e.target.value,
                                    )
                                  }
                                  disabled={
                                    getDisabledStatus ||
                                    item?.bankNotListed !== "No"
                                  }
                                />
                              </Col>

                              <Col
                                xs={12}
                                md={4}
                                lg={4}
                                className="commTopButtonRightLeftPadding"
                              >
                                <InputField
                                  className="inputBox"
                                  label="IBAN"
                                  name="iban"
                                  placeholder=""
                                  value={item?.iban}
                                  onChange={(e) =>
                                    handleChangeBankInfo(
                                      index,
                                      "iban",
                                      e.target.value,
                                    )
                                  }
                                  onBlur={(e) =>
                                    onBankFieldBlur(index, "iban", e.target.value)
                                  }
                                  disabled={getDisabledStatus}
                                  error={bankErrors.iban}
                                />
                              </Col>

                              <Col
                                xs={12}
                                md={4}
                                lg={4}
                                className="commTopButtonRightLeftPadding"
                              >
                                <InputField
                                  className="inputBox"
                                  label="Name of Beneficiary"
                                  extraLabel="Name of Beneficiary (Bank Account Holder Name) as per company /trade license"
                                  name="AccountHolderName"
                                  placeholder=""
                                  value={item?.AccountHolderName || ""}
                                  onChange={(e) =>
                                    handleChangeBankInfo(
                                      index,
                                      "AccountHolderName",
                                      e.target.value,
                                    )
                                  }
                                  disabled={getDisabledStatus}
                                  required={true}
                                  error={bankErrors.AccountHolderName}
                                />
                              </Col>

                              <Col
                                xs={12}
                                md={4}
                                lg={4}
                                className="commTopButtonRightLeftPadding"
                              >
                                {/* Was a Yes/No dropdown, so the DB stored "Yes" instead of the actual code */}
                                <InputField
                                  className="inputBox"
                                  label="Swift / IFSC Code"
                                  extraLabel="IFSC for Indian banks (e.g. ICIC0001234), SWIFT/BIC for others"
                                  name="swiftIfscCode"
                                  placeholder=""
                                  value={item?.swiftIfscCode || ""}
                                  onChange={(e) =>
                                    handleChangeBankInfo(
                                      index,
                                      "swiftIfscCode",
                                      e.target.value.toUpperCase().trim(),
                                    )
                                  }
                                  onBlur={(e) =>
                                    onBankFieldBlur(
                                      index,
                                      "swiftIfscCode",
                                      e.target.value,
                                    )
                                  }
                                  maxLength={11}
                                  disabled={getDisabledStatus}
                                  required={true}
                                  error={bankErrors.swiftIfscCode}
                                />
                              </Col>

                              <Col
                                xs={12}
                                md={4}
                                lg={4}
                                className="commTopButtonRightLeftPadding d-flex"
                              >
                                {!getDisabledStatus && (
                                  <FileUploadComponent
                                    id="bankCompanyletterhead"
                                    name="bankCompanyletterhead"
                                    label="Company letterhead"
                                    allowedTypes={[
                                      "image/png",
                                      "image/jpeg",
                                      "application/pdf",
                                    ]}
                                    multiple={true}
                                    required={true}
                                    onSuccessUpload={(data) =>
                                      onSuccessUploadBankDocumentType(data, index)
                                    }
                                    value={item?.bankCompanyletterhead || ""}
                                    error={bankErrors.bankCompanyletterhead}
                                  />
                                )}
                                <div className="d-flex align-items-center pe-2">
                                  {(item?.bankCompanyletterhead && (
                                    <img
                                      src="assets/img/newIcons/attached-file.png"
                                      className="mt-1 attachmentIcon"
                                      alt="attachments"
                                      onClick={() =>
                                        handleViewFile(
                                          item?.bankCompanyletterhead,
                                        )
                                      }
                                    />
                                  )) ||
                                    "--"}
                                </div>
                              </Col>

                              <Col
                                xs={12}
                                md={4}
                                lg={4}
                                className="commTopButtonRightLeftPadding d-flex"
                              >
                                {!getDisabledStatus && (
                                  <FileUploadComponent
                                    id="bankConfirmationLetter"
                                    name="bankConfirmationLetter"
                                    label="Confirmation letter"
                                    allowedTypes={[
                                      "image/png",
                                      "image/jpeg",
                                      "application/pdf",
                                    ]}
                                    multiple={true}
                                    required={true}
                                    onSuccessUpload={(data) =>
                                      onSuccessUploadBankDocumentType(data, index)
                                    }
                                    value={item?.bankConfirmationLetter || ""}
                                    error={bankErrors.bankConfirmationLetter}
                                  />
                                )}
                                <div className="d-flex align-items-center pe-2">
                                  {(item?.bankConfirmationLetter && (
                                    <img
                                      src="assets/img/newIcons/attached-file.png"
                                      className="mt-1 attachmentIcon"
                                      alt="attachments"
                                      onClick={() =>
                                        handleViewFile(
                                          item?.bankConfirmationLetter,
                                        )
                                      }
                                    />
                                  )) ||
                                    "--"}
                                </div>
                              </Col>

                              <Col
                                xs={12}
                                md={4}
                                lg={4}
                                className="commTopButtonRightLeftPadding d-flex"
                              >
                                {!getDisabledStatus && (
                                  <FileUploadComponent
                                    id="chipsCode"
                                    name="chipsCode"
                                    label="Correspondence Bank Details"
                                    allowedTypes={[
                                      "image/png",
                                      "image/jpeg",
                                      "application/pdf",
                                    ]}
                                    multiple={true}
                                    required={true}
                                    onSuccessUpload={(data) =>
                                      onSuccessUploadBankDocumentType(data, index)
                                    }
                                    value={item?.chipsCode || ""}
                                    error={bankErrors.chipsCode}
                                  />
                                )}
                                <div className="d-flex align-items-center pe-2">
                                  {(item?.chipsCode && (
                                    <img
                                      src="assets/img/newIcons/attached-file.png"
                                      className="mt-1 attachmentIcon"
                                      alt="attachments"
                                      onClick={() =>
                                        handleViewFile(item?.chipsCode)
                                      }
                                    />
                                  )) ||
                                    "--"}
                                </div>
                              </Col>

                              <Col
                                xs={12}
                                md={12}
                                lg={12}
                                className="commTopButtonRightLeftPadding"
                              >
                                <hr />
                              </Col>
                            </Row>

                            {/* ===== Section 2: Financial Performance ===== */}
                            <Row className="pt-2 pb-4">
                              <Col
                                xs={12}
                                md={12}
                                lg={12}
                                className="commTopButtonRightLeftPadding"
                              >
                                <h6>
                                  Section {index + 2}: Financial Performance
                                </h6>
                              </Col>

                              <Col
                                xs={12}
                                md={4}
                                lg={4}
                                className="commTopButtonRightLeftPadding"
                              >
                                <InputField
                                  className="inputBox"
                                  label="Year 1 - Turnover"
                                  extraLabel="Year 1 - Company turnover supported by documentary evidence"
                                  name="turnover1"
                                  placeholder=""
                                  value={item.turnover1 || ""}
                                  onChange={(e) =>
                                    handleChangeBankInfo(
                                      index,
                                      "turnover1",
                                      e.target.value,
                                    )
                                  }
                                />
                              </Col>

                              <Col
                                xs={12}
                                md={4}
                                lg={4}
                                className="commTopButtonRightLeftPadding"
                              >
                                <InputField
                                  className="inputBox"
                                  label="Year 2 - Turnover"
                                  extraLabel="Year 2 - Company turnover supported by documentary evidence"
                                  name="turnover2"
                                  placeholder=""
                                  value={item.turnover2 || ""}
                                  onChange={(e) =>
                                    handleChangeBankInfo(
                                      index,
                                      "turnover2",
                                      e.target.value,
                                    )
                                  }
                                />
                              </Col>

                              <Col
                                xs={12}
                                md={4}
                                lg={4}
                                className="commTopButtonRightLeftPadding"
                              >
                                <InputField
                                  className="inputBox"
                                  label="Year 3 - Turnover"
                                  extraLabel="Year 3 - Company turnover supported by documentary evidence"
                                  name="turnover3"
                                  placeholder=""
                                  value={item.turnover3 || ""}
                                  onChange={(e) =>
                                    handleChangeBankInfo(
                                      index,
                                      "turnover3",
                                      e.target.value,
                                    )
                                  }
                                />
                              </Col>

                              <Col
                                xs={12}
                                md={4}
                                lg={4}
                                className="commTopButtonRightLeftPadding d-flex"
                              >
                                {!getDisabledStatus && (
                                  <FileUploadComponent
                                    id="turnover1Atch"
                                    name="turnover1Atch"
                                    label="Year 1 - Turnover"
                                    allowedTypes={[
                                      "image/png",
                                      "image/jpeg",
                                      "application/pdf",
                                    ]}
                                    multiple={true}
                                    required={true}
                                    onSuccessUpload={(data) =>
                                      onSuccessUploadBankDocumentType(data, index)
                                    }
                                    value={item?.turnover1Atch || ""}
                                    error={bankErrors.turnover1Atch}
                                  />
                                )}
                                <div className="d-flex align-items-center pe-2">
                                  {(item?.turnover1Atch && (
                                    <img
                                      src="assets/img/newIcons/attached-file.png"
                                      className="mt-1 attachmentIcon"
                                      alt="attachments"
                                      onClick={() =>
                                        handleViewFile(item?.turnover1Atch)
                                      }
                                    />
                                  )) ||
                                    "--"}
                                </div>
                              </Col>

                              <Col
                                xs={12}
                                md={4}
                                lg={4}
                                className="commTopButtonRightLeftPadding d-flex"
                              >
                                {!getDisabledStatus && (
                                  <FileUploadComponent
                                    id="turnover2Atch"
                                    name="turnover2Atch"
                                    label="Year 2 - Turnover"
                                    allowedTypes={[
                                      "image/png",
                                      "image/jpeg",
                                      "application/pdf",
                                    ]}
                                    multiple={true}
                                    required={true}
                                    onSuccessUpload={(data) =>
                                      onSuccessUploadBankDocumentType(data, index)
                                    }
                                    value={item?.turnover2Atch || ""}
                                    error={bankErrors.turnover2Atch}
                                  />
                                )}
                                <div className="d-flex align-items-center pe-2">
                                  {(item?.turnover2Atch && (
                                    <img
                                      src="assets/img/newIcons/attached-file.png"
                                      className="mt-1 attachmentIcon"
                                      alt="attachments"
                                      onClick={() =>
                                        handleViewFile(item?.turnover2Atch)
                                      }
                                    />
                                  )) ||
                                    "--"}
                                </div>
                              </Col>

                              <Col
                                xs={12}
                                md={4}
                                lg={4}
                                className="commTopButtonRightLeftPadding d-flex"
                              >
                                {!getDisabledStatus && (
                                  <FileUploadComponent
                                    id="turnover3Atch"
                                    name="turnover3Atch"
                                    label="Year 3 - Turnover"
                                    allowedTypes={[
                                      "image/png",
                                      "image/jpeg",
                                      "application/pdf",
                                    ]}
                                    multiple={true}
                                    onSuccessUpload={(data) =>
                                      onSuccessUploadBankDocumentType(data, index)
                                    }
                                    value={item?.turnover3Atch || ""}
                                  />
                                )}
                                <div className="d-flex align-items-center pe-2">
                                  {(item?.turnover3Atch && (
                                    <img
                                      src="assets/img/newIcons/attached-file.png"
                                      className="mt-1 attachmentIcon"
                                      alt="attachments"
                                      onClick={() =>
                                        handleViewFile(item?.turnover3Atch)
                                      }
                                    />
                                  )) ||
                                    "--"}
                                </div>
                              </Col>

                              <Col
                                xs={12}
                                md={4}
                                lg={4}
                                className="commTopButtonRightLeftPadding"
                              >
                                <InputField
                                  className="inputBox"
                                  label="Financial Documents Upload"
                                  extraLabel="Upload any additional financial documents"
                                  name="financialDocNote"
                                  placeholder=""
                                  value={item.financialDocNote || ""}
                                  onChange={(e) =>
                                    handleChangeBankInfo(
                                      index,
                                      "financialDocNote",
                                      e.target.value,
                                    )
                                  }
                                />
                              </Col>

                              <Col
                                xs={12}
                                md={4}
                                lg={4}
                                className="commTopButtonRightLeftPadding d-flex"
                              >
                                {!getDisabledStatus && (
                                  <FileUploadComponent
                                    id="financialUploadDocument"
                                    name="financialUploadDocument"
                                    label="Financial DOC"
                                    allowedTypes={[
                                      "image/png",
                                      "image/jpeg",
                                      "application/pdf",
                                    ]}
                                    multiple={true}
                                    onSuccessUpload={(data) =>
                                      onSuccessUploadBankDocumentType(data, index)
                                    }
                                    value={item?.financialUploadDocument || ""}
                                  />
                                )}
                                <div className="d-flex align-items-center pe-2">
                                  {(item?.financialUploadDocument && (
                                    <img
                                      src="assets/img/newIcons/attached-file.png"
                                      className="mt-1 attachmentIcon"
                                      alt="attachments"
                                      onClick={() =>
                                        handleViewFile(
                                          item?.financialUploadDocument,
                                        )
                                      }
                                    />
                                  )) ||
                                    "--"}
                                </div>
                              </Col>

                              <Col
                                xs={12}
                                md={12}
                                lg={12}
                                className="commTopButtonRightLeftPadding"
                              >
                                <hr />
                              </Col>
                            </Row>
                          </div>
                        );
                      })}
                  </div>
                </div>
              </div>
            </div>

            <div className="accordion mb-4" id="accordionExample">
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <Row className="accordion-button">
                    <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                      <i
                        className={`bi ${isCardVisible3 ? "bi-chevron-right" : "bi-chevron-down"}`}
                        onClick={toggleCardVisibility3}
                      ></i>
                    </Col>
                    <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                      <span className="iconLogo">DC</span>
                    </Col>
                    <Col xs={8} md={9} lg={9}>
                      <span className="headerTitle">Declaration</span>
                      <span className="subHeaderTitle">
                        Additional Information
                      </span>
                    </Col>
                  </Row>
                </h2>

                <div
                  className={`accordion-collapse collapse show ${isCardVisible3 ? "visible" : ""}`}
                >
                  <div className="accordion-body">
                    <Row className="pt-2 pb-4">
                      {/* <Col xs={12} md={4} lg={4} className="commTopButtonRightLeftPadding d-flex">
            {!getDisabledStatus && (
              <FileUploadComponent
                id="conflictInterestDeclaration"
                name="conflictInterestDeclaration"
                label="Conflict of Interest Declaration"
                allowedTypes={["image/png", "image/jpeg", "application/pdf"]}
                multiple={true}
                required={true}
                onSuccessUpload={onSuccessUploadfiles}
                value={formInputs?.conflictInterestDeclaration || ""}
              />
              
            )}
            <div className="d-flex align-items-center pe-2">
              {(formInputs?.conflictInterestDeclaration && (
                <img
                  src="assets/img/newIcons/attached-file.png"
                  className="mt-1 attachmentIcon"
                  alt="attachments"
                  onClick={() => handleViewFile(formInputs?.conflictInterestDeclaration)}
                />
              )) || "--"}
            </div>
          </Col> */}
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding d-flex"
                      >
                        {!getDisabledStatus && (
                          <div className="d-flex align-items-center">
                            <FileUploadComponent
                              id="conflictInterestDeclaration"
                              name="conflictInterestDeclaration"
                              label={
                                <div className="d-flex align-items-center gap-2">
                                  <span>Conflict of Interest Declaration</span>
                                  <i
                                    className="bi bi-download"
                                    style={{
                                      cursor: "pointer",
                                      fontSize: "16px",
                                      color: "blue",
                                    }}
                                    title="Download Sample PDF"
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      const link = document.createElement("a");
                                      link.href =
                                        "/assets/img/declaration_pdfs/conflict_of_interest_declaration_sample.pdf";
                                      link.download =
                                        "conflict_of_interest_declaration_sample.pdf";
                                      document.body.appendChild(link);
                                      link.click();
                                      document.body.removeChild(link);
                                    }}
                                  ></i>
                                </div>
                              }
                              allowedTypes={[
                                "image/png",
                                "image/jpeg",
                                "application/pdf",
                              ]}
                              multiple={true}
                              // required={true}
                              onSuccessUpload={onSuccessUploadfiles}
                              value={
                                formInputs?.conflictInterestDeclaration || ""
                              }
                            />
                          </div>
                        )}
                        <div className="d-flex align-items-center pe-2 ms-2">
                          {(formInputs?.conflictInterestDeclaration && (
                            <img
                              src="assets/img/newIcons/attached-file.png"
                              className="mt-1 attachmentIcon"
                              alt="attachments"
                              onClick={() =>
                                handleViewFile(
                                  formInputs?.conflictInterestDeclaration,
                                )
                              }
                            />
                          )) ||
                            "--"}
                        </div>
                      </Col>
                      {/* <Col xs={12} md={4} lg={4} className="commTopButtonRightLeftPadding d-flex">
            {!getDisabledStatus && (
              <FileUploadComponent
                id="vendorCodeOfConduct"
                name="vendorCodeOfConduct"
                label="Vendor Code of Conduct"
                allowedTypes={["image/png", "image/jpeg", "application/pdf"]}
                multiple={true}
                // required={true}
                onSuccessUpload={onSuccessUploadfiles}
                value={formInputs?.vendorCodeOfConduct || ""}
              />
            )}
            <div className="d-flex align-items-center pe-2">
              {(formInputs?.vendorCodeOfConduct && (
                <img
                  src="assets/img/newIcons/attached-file.png"
                  className="mt-1 attachmentIcon"
                  alt="attachments"
                  onClick={() => handleViewFile(formInputs?.vendorCodeOfConduct)}
                />
              )) || "--"}
            </div>
          </Col> */}
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding d-flex"
                      >
                        {!getDisabledStatus && (
                          <div className="d-flex align-items-center">
                            <FileUploadComponent
                              id="vendorCodeOfConduct"
                              name="vendorCodeOfConduct"
                              label={
                                <div className="d-flex align-items-center gap-2">
                                  <span>Vendor Code of Conduct</span>
                                  <i
                                    className="bi bi-download"
                                    style={{
                                      cursor: "pointer",
                                      fontSize: "16px",
                                      color: "blue",
                                    }}
                                    title="Download Sample PDF"
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      const link = document.createElement("a");
                                      link.href =
                                        "/assets/img/declaration_pdfs/construction_code_of_conduct.pdf";
                                      link.download =
                                        "construction_code_of_conduct.pdf";
                                      document.body.appendChild(link);
                                      link.click();
                                      document.body.removeChild(link);
                                    }}
                                  ></i>
                                </div>
                              }
                              allowedTypes={[
                                "image/png",
                                "image/jpeg",
                                "application/pdf",
                              ]}
                              multiple={true}
                              onSuccessUpload={onSuccessUploadfiles}
                              value={formInputs?.vendorCodeOfConduct || ""}
                            />
                          </div>
                        )}
                        <div className="d-flex align-items-center pe-2 ms-2">
                          {(formInputs?.vendorCodeOfConduct && (
                            <img
                              src="assets/img/newIcons/attached-file.png"
                              className="mt-1 attachmentIcon"
                              alt="attachments"
                              onClick={() =>
                                handleViewFile(formInputs?.vendorCodeOfConduct)
                              }
                            />
                          )) ||
                            "--"}
                        </div>
                      </Col>

                      {/* <Col xs={12} md={4} lg={4} className="commTopButtonRightLeftPadding d-flex">
            {!getDisabledStatus && (
              <FileUploadComponent
                id="antiBriberyPolicy"
                name="antiBriberyPolicy"
                label="Anti-Bribery and Corruption Policy"
                allowedTypes={["image/png", "image/jpeg", "application/pdf"]}
                multiple={true}
                onSuccessUpload={onSuccessUploadfiles}
                value={formInputs?.antiBriberyPolicy || ""}
              />
            )}
            <div className="d-flex align-items-center pe-2">
              {(formInputs?.antiBriberyPolicy && (
                <img
                  src="assets/img/newIcons/attached-file.png"
                  className="mt-1 attachmentIcon"
                  alt="attachments"
                  onClick={() => handleViewFile(formInputs?.antiBriberyPolicy)}
                />
              )) || "--"}
            </div>
          </Col> */}
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding d-flex"
                      >
                        {!getDisabledStatus && (
                          <div className="d-flex align-items-center">
                            <FileUploadComponent
                              id="antiBriberyPolicy"
                              name="antiBriberyPolicy"
                              label={
                                <div className="d-flex align-items-center gap-2">
                                  <span>
                                    Anti-Bribery and Corruption Policy
                                  </span>
                                  <i
                                    className="bi bi-download"
                                    style={{
                                      cursor: "pointer",
                                      fontSize: "16px",
                                      color: "blue",
                                    }}
                                    title="Download Sample PDF"
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      const link = document.createElement("a");
                                      link.href =
                                        "/assets/img/declaration_pdfs/antibribery_and_anti_corruption_policy_construction_industry.pdf";
                                      link.download =
                                        "antibribery_and_anti_corruption_policy_construction_industry.pdf";
                                      document.body.appendChild(link);
                                      link.click();
                                      document.body.removeChild(link);
                                    }}
                                  ></i>
                                </div>
                              }
                              allowedTypes={[
                                "image/png",
                                "image/jpeg",
                                "application/pdf",
                              ]}
                              multiple={true}
                              onSuccessUpload={onSuccessUploadfiles}
                              value={formInputs?.antiBriberyPolicy || ""}
                            />
                          </div>
                        )}
                        <div className="d-flex align-items-center pe-2 ms-2">
                          {(formInputs?.antiBriberyPolicy && (
                            <img
                              src="assets/img/newIcons/attached-file.png"
                              className="mt-1 attachmentIcon"
                              alt="attachments"
                              onClick={() =>
                                handleViewFile(formInputs?.antiBriberyPolicy)
                              }
                            />
                          )) ||
                            "--"}
                        </div>
                      </Col>
                    </Row>
                  </div>
                </div>
              </div>
            </div>
            {/* <div className="accordion mb-4" id="accordionExample">
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <Row className="accordion-button">
                    <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                      <i
                        className={`bi ${
                          isCardVisible5
                            ? "bi-chevron-right"
                            : "bi-chevron-down"
                        }`}
                        onClick={toggleCardVisibility5}
                      ></i>
                    </Col>
                    <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                      <span className="iconLogo">SI</span>
                    </Col>
                    <Col xs={8} md={9} lg={9}>
                      <span className="headerTitle">SAP Information</span>
                      <span className="subHeaderTitle">
                        SAP Information of Supplier
                      </span>
                    </Col>

                  </Row>
                </h2>

                <div
                  className={`accordion-collapse collapse show ${
                    isCardVisible5 ? "visible" : ""
                  }`}
                >
                  <div className="accordion-body">
                    <Row className="pt-2 pb-4">
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Account Group"
                          name="accountGroup"
                          placeholder=""
                          value={formInputs.accountGroup || ""}
                          onChange={onInputChange}
                          disabled={true}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <ComboboxField
                          label="Company Code"
                          extraLabel="SAP Company Code"
                          placeholder=""
                          data={getCompanyCode}
                          id="companyCode"
                          iconClassName="dropdownIcon"
                          name="companyCode"
                          setValue={formInputs.companyCode || ""}
                          getvalue={setDropdownData}
                          onChange={onInputChange}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <ComboboxField
                          label="Purchase Organization"
                          extraLabel="SAP Purchase organization"
                          placeholder=""
                          data={getPurchaseOrg}
                          id="purchaseOrg"
                          iconClassName="dropdownIcon"
                          name="purchaseOrg"
                          setValue={formInputs.purchaseOrg || ""}
                          getvalue={setDropdownData}
                          onChange={onInputChange}
                        />
                      </Col>
                    </Row>
                  </div>
                </div>
              </div>
            </div> */}
            {formInputs.supplierTypeCode === "S02" && (
              <>
                <div className="accordion mb-4" id="accordionExample">
                  <div className="accordion-item">
                    <h2 className="accordion-header">
                      <Row className="accordion-button">
                        <Col
                          xs={1}
                          md={1}
                          lg={1}
                          className="text-left arrowBtn"
                        >
                          <i
                            className={`bi ${
                              isCardVisible4
                                ? "bi-chevron-right"
                                : "bi-chevron-down"
                            }`}
                            onClick={toggleCardVisibility4}
                          ></i>
                        </Col>
                        <Col
                          xs={1}
                          md={1}
                          lg={1}
                          className="text-center logoBtn"
                        >
                          <span className="iconLogo">FD</span>
                        </Col>

                        <Col xs={8} md={8} lg={8}>
                          <span className="headerTitle">Factory Details </span>
                          <span className="subHeaderTitle">
                            Factory Details
                          </span>
                        </Col>

                        <Col xs={4} md={2} lg={2}>
                          <div className="d-flex justify-content-end  p-2 me-3">
                            <button
                              className="btnTable"
                              onClick={() => addProjectDetails()}
                            >
                              <i className="bi bi-plus-lg"></i> Add Factory
                            </button>
                          </div>
                        </Col>
                      </Row>
                    </h2>
                    <div
                      className={`accordion-collapse collapse show ${
                        isCardVisible4 ? "visible" : ""
                      }`}
                    >
                      <div className="accordion-body">
                        {formInputs.projectDetails &&
                          formInputs.projectDetails?.map((item, index) => (
                            <div key={index}>
                              <Row className="pt-2 pb-4">
                                <Col
                                  xs={12}
                                  md={12}
                                  lg={12}
                                  className="commTopButtonRightLeftPadding"
                                >
                                  <h5 className="bg-table-status bg-table-new-status mt-3 p-3">
                                    Factory Details {index + 1}
                                  </h5>
                                  <span
                                    className="deleteIconAccordion"
                                    onClick={() => removeProjectDetails(index)}
                                  >
                                    {" "}
                                    <i className="bi bi-x-circle"></i>{" "}
                                  </span>
                                </Col>
                                <Col
                                  xs={12}
                                  md={4}
                                  lg={4}
                                  className="commTopButtonRightLeftPadding"
                                >
                                  <InputField
                                    className="inputBox"
                                    label="Factory Name"
                                    extraLabel="As per the trade license"
                                    name="projectName"
                                    value={item.projectName || ""}
                                    onChange={(e) =>
                                      handleProjectInputChange(
                                        e.target.value,
                                        index,
                                        "projectName",
                                      )
                                    }
                                    required={true}
                                  />
                                </Col>
                                <Col
                                  xs={12}
                                  md={4}
                                  lg={4}
                                  className="commTopButtonRightLeftPadding"
                                >
                                  <InputField
                                    className="inputBox"
                                    label="Address Lines 1 / Street"
                                    extraLabel="As per the trade license"
                                    name="projectAddress"
                                    value={item.projectAddress || ""}
                                    onChange={(e) =>
                                      handleProjectInputChange(
                                        e.target.value,
                                        index,
                                        "projectAddress",
                                      )
                                    }
                                    required={true}
                                  />
                                </Col>
                                <Col
                                  xs={12}
                                  md={4}
                                  lg={4}
                                  className="commTopButtonRightLeftPadding"
                                >
                                  <InputField
                                    className="inputBox"
                                    label="Address Line 2"
                                    extraLabel="As per the trade license"
                                    name="projectAddress2"
                                    value={item.projectAddress2 || ""}
                                    onChange={(e) =>
                                      handleProjectInputChange(
                                        e.target.value,
                                        index,
                                        "projectAddress2",
                                      )
                                    }
                                    required={true}
                                  />
                                </Col>
                                <Col
                                  xs={12}
                                  md={4}
                                  lg={4}
                                  className="commTopButtonRightLeftPadding"
                                >
                                  <InputField
                                    className="inputBox"
                                    label="City"
                                    extraLabel="As per the trade license"
                                    name="projectCity"
                                    value={item.projectCity || ""}
                                    onChange={(e) =>
                                      handleProjectInputChange(
                                        e.target.value,
                                        index,
                                        "projectCity",
                                      )
                                    }
                                    required={true}
                                  />
                                </Col>
                                <Col
                                  xs={12}
                                  md={4}
                                  lg={4}
                                  className="commTopButtonRightLeftPadding"
                                >
                                  {/* <ComboboxField2
                                  label="Country"
                                  placeholder=""
                                  data={getCountry}
                                  id="projectCountry"
                                  iconClassName="dropdownIcon"
                                  name="projectCountry"
                                  code="projectCountryCode"
                                  description="projectCountryDesc"
                                  setValue={item?.projectCountry}
                                  value={item?.projectCountry}
                                  getvalue={setDropdownData}
                                  // index={item.id}
                                  index={index}
                                  onChangeValue={(value) =>
                                    handleProjectInputChange(
                                      value,
                                      index,
                                      "projectCountry"
                                    )
                                  }
                                /> */}

                                  <ComboboxField
                                    label="Country"
                                    placeholder=""
                                    data={getCountry}
                                    id="projectCountry"
                                    iconClassName="dropdownIcon"
                                    name="projectCountry"
                                    code="projectCountryCode"
                                    description="projectCountryDesc"
                                    setValue={item?.projectCountry}
                                    getvalue={setDropdownData}
                                    // index={item.id}
                                    index={index}
                                    // onChangeValue={(value) =>
                                    //   handleProjectInputChange(
                                    //     value,
                                    //     index,
                                    //     "projectCountry"
                                    //   )
                                    // }

                                    // error={validation.country}
                                    // required={true}
                                  />
                                </Col>

                                <Col
                                  xs={12}
                                  md={4}
                                  lg={4}
                                  className="commTopButtonRightLeftPadding"
                                >
                                  {/* <ComboboxField2
                                  label="State"
                                  placeholder=""
                                  data={getState}
                                  id="projectState"
                                  iconClassName="dropdownIcon"
                                  name="projectState"
                                  code="projectStateCode"
                                  description="projectStateDesc"
                                  setValue={item?.projectState}
                                  value={item?.projectState}
                                  getvalue={setDropdownData}
                                  // index={item.id}
                                  index={index}
                                  onChangeValue={(value) =>
                                    handleProjectInputChange(
                                      value,
                                      index,
                                      "projectState"
                                    )
                                  }
                                /> */}

                                  <ComboboxField
                                    // Remount per country (see company State dropdown)
                                    key={`projectState-${countryCodeOf(item?.projectCountry, item?.projectCountryCode)}`}
                                    fireOnMount={false}
                                    label="State"
                                    placeholder=""
                                    data={
                                      statesByCountry[
                                        countryCodeOf(
                                          item?.projectCountry,
                                          item?.projectCountryCode,
                                        )
                                      ] || []
                                    }
                                    id="projectState"
                                    iconClassName="dropdownIcon"
                                    name="projectState"
                                    code="projectStateCode"
                                    description="projectStateDesc"
                                    setValue={item?.projectState}
                                    getvalue={setDropdownData}
                                    // index={item.id}
                                    index={index}
                                    // error={validation.state}
                                    // required={true}
                                    //  onChangeValue={(value) =>
                                    //   handleProjectInputChange(
                                    //     value,
                                    //     index,
                                    //     "projectState"
                                    //   )
                                    // }
                                  />
                                </Col>

                                <Col
                                  xs={12}
                                  md={4}
                                  lg={4}
                                  className="commTopButtonRightLeftPadding"
                                >
                                  <InputField
                                    className="inputBox"
                                    label="Postal Code/PO Box"
                                    extraLabel="As per the trade license"
                                    name="projectCityPostalCode"
                                    value={item.projectCityPostalCode || ""}
                                    onChange={(e) =>
                                      handleProjectInputChange(
                                        e.target.value,
                                        index,
                                        "projectCityPostalCode",
                                      )
                                    }
                                    required={true}
                                  />
                                </Col>
                              </Row>

                              <Row>
                                <Col
                                  xs={12}
                                  md={12}
                                  lg={12}
                                  className="commTopButtonRightLeftPadding"
                                >
                                  <div>
                                    <div className="d-flex-column justify-content-center">
                                      <Row>
                                        <Col xs={12} md={5} lg={5}>
                                          <h5 className="bg-table-status bg-table-warning-status mt-1">
                                            Factory Contacts
                                          </h5>
                                        </Col>

                                        <Col xs={12}>
                                          <div className="accordion-body">
                                            <div className="d-flex-column justify-content-center">
                                              <Row className="pt-4 d-none d-lg-flex ">
                                                <Col xs={12} md={2} lg={2}>
                                                  <p className="fs-6 fw-medium d-flex ms-4">
                                                    Job Title
                                                  </p>
                                                </Col>
                                                <Col xs={12} md={4} lg={2}>
                                                  <p className="fs-6 fw-medium d-flex ms-4">
                                                    Contact Title
                                                  </p>
                                                </Col>
                                                <Col xs={12} md={4} lg={2}>
                                                  <p className="fs-6 fw-medium d-flex ms-4">
                                                    Contact Person
                                                  </p>
                                                </Col>
                                                <Col xs={12} md={4} lg={2}>
                                                  <p className="fs-6 fw-medium d-flex ms-4">
                                                    Contact Number
                                                  </p>
                                                </Col>
                                                <Col xs={12} md={4} lg={2}>
                                                  <p className="fs-6 fw-medium d-flex ms-4">
                                                    Email-ID
                                                  </p>
                                                </Col>
                                                <Col xs={12} md={4} lg={2}>
                                                  <p className="fs-6 fw-medium d-flex">
                                                    Action
                                                  </p>
                                                </Col>
                                              </Row>
                                              {item?.getProjectContactPerson.map(
                                                (doc, itemIndex) => (
                                                  <Row key={doc.id}>
                                                    <Col xs={12}>
                                                      <hr className="mx-4 my-0 text-color-black" />
                                                    </Col>
                                                    <Col
                                                      xs={12}
                                                      md={4}
                                                      lg={2}
                                                      className="commTopButtonRightLeftPadding"
                                                    >
                                                      <ComboboxFieldSubArray
                                                        label=""
                                                        placeholder="Job Title"
                                                        data={
                                                          getcontactPosition
                                                        }
                                                        id="projectContactPosition"
                                                        name="projectContactPosition"
                                                        code="projectContactPositionCode"
                                                        description="projectContactPositionDesc"
                                                        setValue={
                                                          doc.projectContactPosition
                                                        }
                                                        index={index} // Pass projectIndex instead of doc.id
                                                        onChangeValue={(
                                                          projectIndex,
                                                          contactId,
                                                          fieldName,
                                                          value,
                                                        ) =>
                                                          handleChangeProjectContactsDropdown(
                                                            projectIndex,
                                                            doc.id,
                                                            fieldName,
                                                            value,
                                                          )
                                                        }
                                                      />
                                                    </Col>
                                                    <Col
                                                      xs={12}
                                                      md={4}
                                                      lg={2}
                                                      className="commTopButtonRightLeftPadding"
                                                    >
                                                      <ComboboxFieldSubArray
                                                        label=""
                                                        placeholder="Contact Title"
                                                        data={getTitle}
                                                        id="projectContactTitle"
                                                        iconClassName="dropdownIcon"
                                                        name="projectContactTitle"
                                                        code="projectContactTitleCode"
                                                        description="projectContactTitleDesc"
                                                        setValue={
                                                          doc.projectContactTitle
                                                        }
                                                        index={index} // Pass projectIndex instead of doc.id
                                                        onChangeValue={(
                                                          projectIndex,
                                                          contactId,
                                                          fieldName,
                                                          value,
                                                        ) =>
                                                          handleChangeProjectContactsDropdown(
                                                            projectIndex,
                                                            doc.id,
                                                            fieldName,
                                                            value,
                                                          )
                                                        }
                                                      />
                                                    </Col>
                                                    <Col
                                                      xs={12}
                                                      md={4}
                                                      lg={2}
                                                      className="commTopButtonRightLeftPadding"
                                                    >
                                                      <InputField
                                                        className="inputBox mt-1"
                                                        name="projectContactName"
                                                        placeholder="Contact Person"
                                                        value={
                                                          doc.projectContactName ||
                                                          ""
                                                        }
                                                        onChange={(e) =>
                                                          handleChangeProjectContacts(
                                                            index,
                                                            doc.id,
                                                            "projectContactName",
                                                            e.target.value,
                                                          )
                                                        }
                                                      />
                                                    </Col>
                                                    <Col
                                                      xs={12}
                                                      md={4}
                                                      lg={2}
                                                      className="commTopButtonRightLeftPadding"
                                                    >
                                                      <InputField
                                                        className="inputBox mt-1"
                                                        name="projectContactNumber"
                                                        placeholder="Contact Number"
                                                        value={
                                                          doc.projectContactNumber ||
                                                          ""
                                                        }
                                                        onChange={(e) =>
                                                          // handleChangeProjectContactsNew(

                                                          handleChangeProjectContacts(
                                                            index,
                                                            doc.id,
                                                            "projectContactNumber",
                                                            e.target.value,
                                                          )
                                                        }
                                                      />
                                                    </Col>
                                                    <Col
                                                      xs={12}
                                                      md={4}
                                                      lg={2}
                                                      className="commTopButtonRightLeftPadding"
                                                    >
                                                      <InputField
                                                        className="inputBox mt-1"
                                                        name="projectContactEmail"
                                                        placeholder="Email"
                                                        value={
                                                          doc.projectContactEmail ||
                                                          ""
                                                        }
                                                        onChange={(e) =>
                                                          handleChangeProjectContacts(
                                                            index,
                                                            doc.id,
                                                            "projectContactEmail",
                                                            e.target.value,
                                                          )
                                                        }
                                                      />
                                                    </Col>
                                                    <Col
                                                      xs={12}
                                                      md={4}
                                                      lg={2}
                                                      className="commTopButtonRightLeftPadding"
                                                    >
                                                      <div className="d-flex">
                                                        {item
                                                          ?.getProjectContactPerson
                                                          .length !== 1 && (
                                                          <i
                                                            onClick={() =>
                                                              deleteProjectContactPerson(
                                                                index,
                                                                doc.id,
                                                              )
                                                            }
                                                            className="bi bi-trash text-danger fs-4"
                                                          />
                                                        )}

                                                        {itemIndex ===
                                                          item
                                                            ?.getProjectContactPerson
                                                            .length -
                                                            1 && (
                                                          <button
                                                            className="btnTable width-40 ml-6 mt-1"
                                                            onClick={() =>
                                                              addProjectContactPerson(
                                                                index,
                                                              )
                                                            } // Fixed: Pass as a callback
                                                          >
                                                            <i className="bi bi-plus-lg"></i>{" "}
                                                            Add
                                                          </button>
                                                        )}
                                                      </div>
                                                    </Col>
                                                  </Row>
                                                ),
                                              )}
                                            </div>
                                          </div>
                                        </Col>
                                      </Row>
                                    </div>
                                  </div>
                                </Col>
                              </Row>

                              <Row>
                                <Col
                                  xs={12}
                                  md={12}
                                  lg={12}
                                  className="commTopButtonRightLeftPadding"
                                >
                                  <div>
                                    <div className="d-flex-column justify-content-center">
                                      <Row>
                                        <Col xs={12} md={5} lg={5}>
                                          <h5 className="bg-table-status bg-table-warning-status mt-4">
                                            Factory Stages
                                          </h5>
                                        </Col>
                                        <Col xs={12}>
                                          <div className="accordion-body">
                                            <div className="d-flex-column justify-content-center">
                                              <Row className="pt-4 d-none d-lg-flex ">
                                                <Col xs={12} md={2} lg={2}>
                                                  <p className="fs-6 fw-medium d-flex ms-4">
                                                    Stages
                                                  </p>
                                                </Col>
                                                <Col xs={12} md={4} lg={1}>
                                                  <p className="fs-6 fw-medium d-flex ms-4">
                                                    View Files
                                                  </p>
                                                </Col>
                                                <Col xs={12} md={4} lg={3}>
                                                  <p className="fs-6 fw-medium d-flex ms-4">
                                                    Attachments
                                                  </p>
                                                </Col>

                                                <Col xs={12} md={4} lg={3}>
                                                  <p className="fs-6 fw-medium d-flex">
                                                    Action
                                                  </p>
                                                </Col>
                                              </Row>
                                              {item.getProjectCertifications.map(
                                                (doc, itemIndex) => (
                                                  <Row key={doc.id}>
                                                    <Col xs={12}>
                                                      <hr className="mx-4 my-0 text-color-black" />
                                                    </Col>
                                                    <Col
                                                      xs={12}
                                                      md={4}
                                                      lg={2}
                                                      className="commTopButtonRightLeftPadding"
                                                    >
                                                      <ComboboxFieldSubArray
                                                        label=""
                                                        placeholder="Stages"
                                                        data={
                                                          productDocumentAttachment
                                                        }
                                                        id="documentType"
                                                        iconClassName="dropdownIcon"
                                                        name="documentType"
                                                        code="documentTypeCode"
                                                        description="documentTypeDesc"
                                                        setValue={
                                                          doc.documentType
                                                        }
                                                        index={index} // Pass projectIndex instead of doc.id
                                                        onChangeValue={(
                                                          projectIndex,
                                                          fileId,
                                                          fieldName,
                                                          value,
                                                        ) =>
                                                          handleChangeProjectContactsDropdown(
                                                            projectIndex,
                                                            doc.id,
                                                            fieldName,
                                                            value,
                                                          )
                                                        }
                                                      />
                                                    </Col>
                                                    {/* <Col
                                                 xs={12}
                                                 md={4}
                                                 lg={1}
                                                 className="commTopButtonRightLeftPadding"
                                               >
                                                 <div className="d-flex justify-content-center">
                                                   {(doc.iSOCertification && (
                                                     <img
                                                       src="assets/img/newIcons/attached-file.png"
                                                       className="mt-1 attachmentIcon"
                                                       alt="attachments"
                                                       onClick={() =>
                                                         handleViewFile(
                                                           doc.iSOCertification
                                                         )
                                                       }
                                                     />
                                                   )) ||
                                                     "--"}
                                                 </div>
                                               </Col> */}
                                                    <Col
                                                      xs={12}
                                                      md={4}
                                                      lg={1}
                                                      className="commTopButtonRightLeftPadding"
                                                    >
                                                      <div className="d-flex justify-content-center">
                                                        {(doc.stageDocument && (
                                                          <img
                                                            src="assets/img/newIcons/attached-file.png"
                                                            className="mt-1 attachmentIcon"
                                                            alt="attachments"
                                                            onClick={() =>
                                                              handleViewFile(
                                                                doc.stageDocument,
                                                              )
                                                            }
                                                          />
                                                        )) ||
                                                          "--"}
                                                      </div>
                                                    </Col>
                                                    <Col
                                                      xs={12}
                                                      md={4}
                                                      lg={3}
                                                      className="commTopButtonRightLeftPadding"
                                                    >
                                                      <FileUploadComponent
                                                        id={doc.id}
                                                        name="stageDocument"
                                                        label=""
                                                        allowedTypes={[
                                                          "image/png",
                                                          "image/jpeg",
                                                          "application/pdf",
                                                        ]}
                                                        multiple={true} // Change to `false` for single file selection
                                                        required={true}
                                                        onSuccessUpload={(
                                                          data,
                                                        ) =>
                                                          onSuccessUploadProjectStageDocument(
                                                            index,
                                                            doc.id,
                                                            data.fieldName,
                                                            data.attachmentId,
                                                          )
                                                        }
                                                        value={
                                                          doc.stageDocument ||
                                                          ""
                                                        }
                                                      />
                                                    </Col>

                                                    <Col
                                                      xs={12}
                                                      md={4}
                                                      lg={2}
                                                      className="commTopButtonRightLeftPadding"
                                                    >
                                                      <div className="d-flex">
                                                        {item
                                                          ?.getProjectCertifications
                                                          .length !== 1 && (
                                                          <i
                                                            onClick={() =>
                                                              deleteProjectCertification(
                                                                index,
                                                                doc.id,
                                                              )
                                                            }
                                                            className="bi bi-trash text-danger fs-4"
                                                          />
                                                        )}

                                                        {itemIndex ===
                                                          item
                                                            ?.getProjectCertifications
                                                            .length -
                                                            1 && (
                                                          <button
                                                            className="btnTable width-40 ml-6 mt-1"
                                                            onClick={() =>
                                                              addProjectCertification(
                                                                index,
                                                              )
                                                            } // Fixed: Pass as a callback
                                                          >
                                                            <i className="bi bi-plus-lg"></i>{" "}
                                                            Add
                                                          </button>
                                                        )}
                                                      </div>
                                                    </Col>
                                                  </Row>
                                                ),
                                              )}
                                            </div>
                                          </div>
                                        </Col>
                                      </Row>
                                    </div>
                                  </div>
                                </Col>
                              </Row>

                              <Row>
                                <Col
                                  xs={12}
                                  md={12}
                                  lg={12}
                                  className="commTopButtonRightLeftPadding"
                                >
                                  <div></div>
                                </Col>
                              </Row>

                              <hr />
                            </div>
                          ))}
                      </div>
                    </div>
                  </div>
                </div>
              </>
            )}
            {/* {formInputs.qms === "Yes" && (<>
              <div className="accordion mb-4" id="accordionExample">
                <div className="accordion-item">
                  <h2 className="accordion-header">
                    <Row className="accordion-button">
                      <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                        <i
                          className={`bi ${isCardVisible3
                            ? "bi-chevron-right"
                            : "bi-chevron-down"
                            }`}
                          onClick={toggleCardVisibility3}
                        ></i>
                      </Col>
                      <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                        <span className="iconLogo">VU</span>
                      </Col>
                      <Col xs={8} md={9} lg={9}>
                        <span className="headerTitle">Venodr Code and MOU Updation</span>
                        <span className="subHeaderTitle">
                          The Venodr Code and Signed MOU Can be Updated for all Incactive New Vendors
                          from Compilance DataBase Post Compilance Approval
                        </span>
                      </Col>
                    </Row>
                  </h2>

                  <div
                    className={`accordion-collapse collapse show ${isCardVisible3 ? "visible" : ""
                      }`}
                  >
                    <div className="accordion-body">
                      <Row className="pt-2 pb-4">
                        <Col
                          xs={12}
                          md={4}
                          lg={4}
                          className="commTopButtonRightLeftPadding"
                        >
                          <InputField
                            className="inputBox"
                            label="Vendor Code"
                            name="vendorCode"
                            placeholder=""
                            value={formInputs.vendorCode || ""}
                            onChange={onInputChange}
                            disabled={false}
                            error={validation.vendorCode}
                            required={true}
                          />

                        </Col>
                        <Col
                          xs={12}
                          md={4}
                          lg={4}
                          className="commTopButtonRightLeftPadding"
                        >
                          <ComboboxField
                            label="MOU"
                            // extraLabel="Certification?"
                            name="mou"
                            // code="ISOCertificationCode"
                            // description="ISOCertificationDesc"
                            data={dropdownOption}
                            id="mou"
                            iconClassName="dropdownIcon"
                            onChange={setDropdownData}
                            setValue={formInputs.mou}
                            error={validation.mou}
                            getvalue={setDropdownData}
                          // required={true}
                          // className="dropdownOption"
                          />

                        </Col>
                        <Col
                          xs={12}
                          md={3}
                          lg={3}
                          className="commTopButtonRightLeftPadding"
                        >
                          <FileUploadComponent
                            name="mouAttachment"
                            label="MOU Attachment"
                            allowedTypes={[
                              "image/png",
                              "image/jpeg",
                              "application/pdf",
                            ]}
                            multiple={true} // Change to `false` for single file selection
                            onSuccessUpload={onSuccessUploadfiles}
                            value={formInputs.mouAttachment || ""}
                          />
                        </Col>
                        <Col
                          xs={12}
                          md={1}
                          lg={1}
                          className="commTopButtonRightLeftPadding m-0 p-0 d-flex justify-content-center align-items-center"
                        >
                          {(formInputs?.mouAttachment && (
                            <img
                              src="assets/img/newIcons/attached-file.png"
                              className="mt-1 attachmentIcon"
                              alt="attachments"
                              onClick={() =>
                                handleViewFile(
                                  formInputs?.mouAttachment
                                )
                              }
                            />
                          )) ||
                            "--"}
                        </Col>
                        <Col
                          xs={12}
                          md={4}
                          lg={4}
                          className="commTopButtonRightLeftPadding"
                        >
                          <InputField
                            className="inputBox"
                            label="MOU Date"
                            name="mouDate"
                            type="date"
                            min={2023}
                            placeholder=""
                            value={formInputs.mouDate || ""}
                            onChange={onInputChange}
                            disabled={false}
                            error={validation.mouDate}
                            required={true}
                          />

                        </Col>
                        <Col
                          xs={12}
                          md={4}
                          lg={4}
                          className="commTopButtonRightLeftPadding"
                        >
                          <InputField
                            className="inputBox"
                            label="Description"
                            name="descriptionMou"
                            placeholder=""
                            value={formInputs.descriptionMou || ""}
                            onChange={onInputChange}
                            disabled={false}
                            error={validation.descriptionMou}
                            required={true}
                          />

                        </Col>
                        <Col
                          xs={12}
                          md={4}
                          lg={4}
                          className="commTopButtonRightLeftPadding"
                        >
                          <InputField
                            className="inputBox"
                            label="Amendment if Any"
                            name="mouamendent"
                            placeholder=""
                            value={formInputs.mouamendent || ""}
                            onChange={onInputChange}
                            disabled={false}
                            error={validation.mouamendent}
                            required={true}
                          />

                        </Col>


                      </Row>
                    </div>
                  </div>
                </div>
              </div>

            </>)} */}
          </div>
        </Col>
      </Row>

      {/* <Row className="rowDirection">
        <Col xs={12} md={2} lg={2} className="">
          <button className="btnTable" onClick={handleSave} disabled={disabled}>
            <i className="bi bi-save"></i> Save
          </button>
        </Col>
      </Row> */}

      <CategorySelectionModal
        show={modalShow}
        onHide={() => hideModal()}
        onselectedcatdata={getSelectedCatData}
      />

      <SuccessRegisterModal
        show={getShowSuccessModal}
        onHide={() => hideSuccessModal()}
        modaldata={getModalInfo}
        aftersuccess={Constants.VENDOR_LIST}
      />

      <FailureModal
        show={getShowFailureModal}
        onHide={() => hideFailureModal()}
        failuremodaldata={getFailureModal}
        requiredfields={getErrorFields}
      />
      <FileViewerModal
        show={getShowFileViewModal}
        onHide={handleViewFileHide}
        fileid={getFileViewData}
      />
    </main>
  );
};

export default SupplierSelfRegistration;
